/* Load Event Start */
window.addEventListener("load", function() {
  let ticking = false;
  function handleMovement(event) {
    if (!ticking) {
      window.requestAnimationFrame(() => {

         if (typeof Swiper === "undefined") {
           loadScriptsDelay(window.swiperscript, function () {
                initializeGlobalSwiperSliders();
                initializeProductSwiperSliders();
          });
        }else{
                initializeGlobalSwiperSliders();
                initializeProductSwiperSliders();
        }
        
        if (window.filtermanager != "") {
          if (typeof FilterManager === 'undefined') {
            loadScriptsDelay(window.filtermanager, function () {
            });
          }
        }
        if (window.ajaxinatescript != "") {
          loadScriptsDelay(window.ajaxinatescript, function () {
            ajaxPagination();
          });
        }
       
        if (window.searchscript != "") {
          loadScriptsDelay(window.searchscript, function () {});
        }
        
        ticking = true;
        makeSectionsVisible('section');
        subMegaMenu();
        customaddtocartscript();
        cartdrawercontent();
        cartdrawernotes();
        cartdrawerdiscount();
        cartdeliverydate();        
        initCookieBanner();
        gridlistview();
        
    	chooseoptpopup();
    	quickviewpopup();
        headerStickyType();
    	wishlist.initButtons_C();
    	comparelist.initButtons_C();
    	comparelist.onchangevariantcompare();
    	productSwatches();
        
        customeractshowhide();
        lookbookscript();
        productvideoplay();
        commonscripts();
        wishlistcomparecount();
        headercriptsLoader();
        updateOrderCount();
        updateVisitorCount();
        if (typeof mobileStickyBottomMenu === 'function') {
          mobileStickyBottomMenu();
        }
        
        if (typeof productlowstockindication === 'function') {
          productlowstockindication();
        }
    	if (typeof addtocartbtnevent === 'function') {
            /*addtocartbtnevent();*/
        }
        if (typeof qtyincdec === 'function') {
            qtyincdec();
        }
        
       
        countdownTimerInitialize();
        exitIntentPopUp();
        ajaxDataInject(".searchdataquicklinks", "search-data-quicklinks", ".searchdataquicklinks", 0);
        ajaxDataInject(".localizationCurrency", "localization-currency", "#shopify-section-localization-currency");
        ajaxDataInject(".localizationLanguage", "localization-language", "#shopify-section-localization-language");
        ajaxDataInject(".menulocalizationlanguage", "menulocalizationlanguage", "#shopify-section-menulocalizationlanguage");
        ajaxDataInject(".menulocalizationcurrency", "menulocalizationcurrency", "#shopify-section-menulocalizationcurrency");
        ajaxDataInject(".contentSalesNotification", "sales-popup-notification", "#shopify-section-sales-popup-notification",0);
        shippingBarConfetti();
        document.addEventListener('visibilitychange', handleTabVisibilityChange, false); 
        productDescriptionTabsControl(); 
      
        if (typeof Masonry === "undefined") {
          loadScriptsDelay(window.masonryscript, function () {
            masonryGrids();
          });
        }else{
           masonryGrids();
        }
        languageCurrencySwitcher();

       
  var headerSection = document.querySelector('.header-section');
  if(headerSection != null){      
    var height = headerSection.offsetHeight;
    headerSection.style.setProperty('--header-height', height+'px');
   /* headerSection.classList.add(document.querySelector('#site-header').dataset.headertransparent);*/
  }

   if (!customElements.get('pagination-form')) {     
    customElements.define('pagination-form', PaginationFiltersForm);
   }
	
  
  if(document.querySelector(".sticky-addtocart-bar-form")){  
    sticky_add_to_cart_bar_product_detail_page();  
  }
    if(document.getElementById('form-status-message-top')){
      setTimeout(function() {
        var container = document.getElementById('form-status-message-top');
        var element = document.getElementById('form-status-message');
        var height = element.offsetHeight;
        element.style.transition = 'height 0.5s ease-in-out, opacity 0.5s ease-in-out';
        element.style.height = height + 'px';
        element.offsetHeight;
        element.style.height = '0';
        element.style.opacity = '0';
        setTimeout(function() {
              element.style.display = 'none';
              container.style.height = '0';
              container.style.overflow = 'hidden';
            }, 500);
        }, 5000);
  }

   
        
    /*======= Start of Sales Notification Code========*/
    
    if(checkIfClassExists(".contentSalesNotification")){
      var contentSalesNotification = document.querySelector(".contentSalesNotification");
      const salesnotification_interval_time = contentSalesNotification.dataset.salesnotification_interval_time;
      const salesnotification_display_device = contentSalesNotification.dataset.salesnotification_display_device;

      if(salesnotification_display_device == "both"){
          /* Call the showSalesNotification function every 10 seconds*/
          setInterval(showSalesNotification, salesnotification_interval_time);
      }else{
          if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            if(salesnotification_display_device == "only_mobile"){
              /* Call the showSalesNotification function every 10 seconds*/
              setInterval(showSalesNotification, salesnotification_interval_time);
            }
          }
          else{
            if(salesnotification_display_device == "only_desktop"){
              /* Call the showSalesNotification function every 10 seconds*/
              setInterval(showSalesNotification, salesnotification_interval_time);
            }
          }
      }
    }
  /*======= End of Sales Notification Code========*/

 /*======== Start Parts Finder Code ==============*/
   let PartFinder = new PartsFinder();
  /*=========End Parts Finder Code =============== */

        if (!customElements.get('deferred-media')) {
          customElements.define('deferred-media', DeferredMedia);
        }
  if (window.ProductModel) window.ProductModel.loadShopifyXR();

  /*========= Start of Multi Add to Cart ===============*/
      multibundle();
   /*========= End of Multi Add to Cart ===============*/
  
 

  /*========= Start Newsletter PopUp Script ===============*/
   var newsletterpops = document.querySelectorAll('.newsletterPopUp');
   if(newsletterpops != null){
    newsletterpops.forEach(function(newspops) {
       PopUpInitialize(newspops,newspops.dataset.apparitiondelay ,newspops.dataset.closedelay,newspops.dataset.showonlyoncepopup);
    });
   }
  /*========= End Newsletter PopUp Script =================*/

        
      });
    }
  }
  /* Event listener without overloading performance */
  const options_listeners = { passive: true};
  document.addEventListener('scroll', handleMovement, options_listeners);
  document.addEventListener('mousemove', handleMovement, options_listeners);
  document.addEventListener('mousedown', handleMovement, options_listeners);
  document.addEventListener('touchstart', handleMovement, options_listeners);
  document.addEventListener('touchmove', handleMovement, options_listeners);
  document.addEventListener('keypress', handleMovement, options_listeners);
  window.addEventListener("resize", handleMovement);
  commonscriptonLoad();
  
}); 
/* Load Event End */




function commonscriptonLoad(){


if (window.storepickupavailability != "") {
      loadScriptsDelay(window.storepickupavailability, function () {});
    }
  loadScriptsDelay(window.swiperscript, function () {});
  if (typeof lazySizes === "undefined") {
    loadScriptsDelay(window.lazyscript, function () {
      lazySizes.init();
    });
  }else{
     lazySizes.init();
  }
 
  if (typeof loadgooglefontdelay === 'function') {
    loadgooglefontdelay();
  }

   if (typeof menuOpenClose === 'function') {
      menuOpenClose();
   }

   scrollPosition();

  /*  document.documentElement.className = document.documentElement.className.replace('no-js', 'js');*/
    if (Shopify.designMode) {
      document.documentElement.classList.add('shopify-design-mode');
    }   
   var commonconfig = document.getElementById("commmonconfigval");
    if(commonconfig){
        var pageloader = commonconfig.dataset.pageloader;
        if(pageloader == "true"){
          document.body.removeChild(document.querySelector('.page-loader-overlay'));
          document.body.classList.remove('page-loading');
          document.body.classList.add('page-loaded');  
        }
        var strtemp = commonconfig.dataset.template;
        if (strtemp.includes("product")) {
        	prodrating();
            observeModal(document.getElementById('chooseoptionModal'));
            observeModal(document.getElementById('quickviewModal'));
        }
    }
  
 

  (function(ns, fetch) {
    if (typeof fetch !== 'function') return;
    ns.fetch = function() {
        
      const response = fetch.apply(this, arguments);
        var flag_view_preference = true;
        
        if (arguments.length > 1 && arguments[1].body && isValidJSON(arguments[1].body)) {
            const parsedBody = JSON.parse(arguments[1].body);
            if (parsedBody.attributes?.view_preference !== undefined) {
               /*console.log('view_preference exists:', parsedBody.attributes.view_preference);*/
               var flag_view_preference = false;
            }
        }
        response.then(res => {
            if ([
                    `${window.location.origin}/cart/add.js`,
                    `${window.location.origin}/cart/update.js`,
                    `${window.location.origin}/cart/change.js`,
                    `${window.location.origin}/cart/clear.js`,
                    `${window.location.origin}/cart/add`,
                    `${window.location.origin}/cart/update`,
                    `${window.location.origin}/cart/change`,
                    `${window.location.origin}/cart/clear`,
                ].includes(res.url)) {
                res.clone().json().then(function(data){ 
                  updateFreeShippingBar();
                  var commonconfigval = document.getElementById("commmonconfigval");
                  if(commonconfigval != null){
                      var template = commonconfigval.dataset.template;
                      if(template != "cart" && flag_view_preference){
                       // updateCartDrawer();
                      }
                  }
                });                  
            }
        });  
        return response;
    }  
  }(window, window.fetch))

 

}

function masonryGrids(){
  
    var masonryGrids = document.querySelectorAll('.masonry-grid');
    if(masonryGrids != null){
      masonryGrids.forEach( masonryGrid => {
        new Masonry( masonryGrid, {
          // options
          itemSelector: '.masonry-grid-item',
          columnWidth: '.grid-sizer',
          percentPosition: true,
        });
      });
 
    }
}


function makeSectionsVisible(className) {
  const sections = document.querySelectorAll(className);
  sections.forEach(section => {
    section.style.contentVisibility = 'visible'; 
  });
}

function loadgooglefontdelay(){
  if(document.querySelector("[data-googlefont]") != null){
    var font_var = document.querySelector("[data-googlefont]").dataset.googlefont;
    if(font_var != null){
      var link = document.createElement('link');
      link.href = `https://fonts.googleapis.com/css2?family=${font_var}&display=swap`; 
      link.rel = 'stylesheet preload';
      link.as = 'style';
      link.type = 'text/css';
      document.head.appendChild(link);
    }
  }
}


function AjaxCallbackEvent(){
  if (typeof StorePickupAvailability === 'undefined' && window.storepickupavailability != "") {
      loadScriptsDelay(window.storepickupavailability, function () {
        productvariantscript();
      });
   }else{
    productvariantscript();
  }  
  multibundle();
  addtocartbtnevent();
  qtyincdec(); 
  countdownTimerInitialize();
  quickviewpopup();
  chooseoptpopup();
  productSwatches();
  wishlist.initButtons_C();
  comparelist.initButtons_C();
  comparelist.onchangevariantcompare();
  gridlistview();
  if (typeof Swiper === "undefined") {
       loadScriptsDelay(window.swiperscript, function () {
            initializeGlobalSwiperSliders();
      });
    }else{
          initializeGlobalSwiperSliders();
    }
}

function isValidJSON(str) {
  try {
      JSON.parse(str);
      return true;
  } catch (e) {
      return false;
  }
}

function countdownTimerInitialize(){
  var countdowntimerelements = document.querySelectorAll('.countdowntimer:not(.listening)');
   if(countdowntimerelements != null){
    countdowntimerelements.forEach(function(countdowntimeritem) {
       countdowntimeritem.classList.add('listening');
       countdowntimer(countdowntimeritem.dataset.cproductid, countdowntimeritem.dataset.csectionid, countdowntimeritem.dataset.ccountdowntimerdate); 	
       
    });
   }
}

function scrollPosition(){
  const scrollPositionKey = `scrollPosition_${window.location.pathname}`;
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  window.addEventListener('beforeunload', function() {
    try {
      const scrollY = window.scrollY;
      sessionStorage.setItem(scrollPositionKey, scrollY);
    } catch (error) {
      console.error('Error saving scroll position to sessionStorage:', error);
    }
  });

  try {
    const savedScrollPosition = sessionStorage.getItem(scrollPositionKey);
    
    if (savedScrollPosition !== null) {
      const scrollY = parseInt(savedScrollPosition, 10);
      window.scrollTo({
        top: scrollY,
        behavior: 'smooth'
      });

      sessionStorage.removeItem(scrollPositionKey);
    } else {
      /*console.log('No saved scroll position found for this page.');*/
    }

    Object.keys(sessionStorage).forEach(key => {
      if (key.startsWith('scrollPosition_') && key !== scrollPositionKey) {
        sessionStorage.removeItem(key);
      }
    });

  } catch (error) {
    console.error('Error retrieving scroll position from sessionStorage:', error);
  }
  
}

function loadScriptsDelay(url, callback) {
  var script = document.createElement("script")
  script.type = "text/javascript";

  if (script.readyState) { 
    script.onreadystatechange = function () {
      if (script.readyState == "loaded" || script.readyState == "complete" || script.readyState == "loading" || dom.readyState == "uninitialized") {
        script.onreadystatechange = null;
        callback();
      }
    };
  }else{ 
    script.onload = function () {
      callback();

    };
  }

  script.type = 'text/javascript';
  script.async = true;
  script.src = url;
  var x = document.getElementsByTagName('script')[0];
  x.parentNode.insertBefore(script, x);

}

function headercriptsLoader() {
  var scripts = document.querySelectorAll('script');
  
  scripts.forEach(function(script) {
    if (script.hasAttribute('data-src')) {
      var newScript = document.createElement('script');
      newScript.src = script.getAttribute('data-src');
      newScript.type = 'text/javascript';  
      
      if (script.innerHTML) {
        newScript.innerHTML = script.innerHTML;
      }

      script.parentNode.replaceChild(newScript, script);
    }
  });
}
/* Start code to manage Rating click tab scroll view in product details page */
function prodrating(){
      if(document.querySelector('[data-block-handle="star_rating"]')){
      if(document.querySelector('[data-block-handle="star_rating"]').querySelector('a')){
        const rating_anchor = document.querySelector('[data-block-handle="star_rating"]').querySelector('a');
        rating_anchor.addEventListener("click", function () {
          document.getElementById('shopify-product-reviews').closest(".collection-tab").click();
          const parentclasslist = document.getElementById('shopify-product-reviews').closest(".collection-tab").classList;
          parentclasslist.forEach((pclasslist) => {
            if(pclasslist.includes("collection-tab-")){
              document.querySelector('[data-collectiontab="'+pclasslist+'"]').click();
              document.querySelector('[data-collectiontab="'+pclasslist+'"]').scrollIntoView();              
            }
          });
        }); 
      }
  }
}
/* End code to manage Rating click tab scroll view in product details page */

/* Start code to manage/update sku + low stock element on product details page */
function observeModal(targetNode) 
{
    var commonconfig = document.getElementById("commmonconfigval");
    if(commonconfig)
    {
      var prodid =  commonconfig.dataset.prodid;
      if(prodid != ""){
        var observer_modal = new MutationObserver(function(){
          if(targetNode.style.display == 'none'){
             productskuupdate_prodid();
             productlowstockindication_prodid();
             
             if(document.querySelector('variant-selects')){
               if(document.querySelector('variant-selects').querySelector('input[type="radio"]')){
                 var elementid = document.querySelector('variant-selects').querySelector('input[type="radio"]:checked').id;
                 document.querySelector('#'+elementid).checked = false; 
                 document.querySelector('#'+elementid).click();
                 document.querySelector('#'+elementid).dispatchEvent(new Event('click'));
               }else if(document.querySelector('variant-selects').querySelectorAll('.select:not(.visually-hidden)')){
                  let selectelements = document.querySelector('variant-selects').querySelectorAll('.select:not(.visually-hidden)');        
                  selectelements.forEach((item) => {
                    let selectelement = item.querySelector('select');
                    let sel_index = selectelement.selectedIndex;
                    selectelement.selectedIndex = -1;
                    selectelement.selectedIndex = sel_index;
                    selectelement.dispatchEvent(new Event('change'));
                  });
                }
            }
          }
        });
        observer_modal.observe(targetNode, { attributes: true, childList: true });  
      }
    }
  }
/* End code to manage/update sku + low stock element on product details page */

function updateFreeShippingBar()
{
  var commonconfig = document.getElementById("commmonconfigval");
  var enableconfettianimation = commonconfig.dataset.enableconfettianimation;
  var currentCurrency = commonconfig.dataset.cartcurrency;
  const freeshippingstatus = document.querySelector('.freeshippingstatus');
  if(freeshippingstatus){
      fetch('/cart.js')
        .then((res) => {
        return res.json();
      }).then(function(cart) {
          var shippingvalue = commonconfig.dataset.shippingvalue;
          var shipping_quotient = shippingvalue / 100;
          var shipping_percent = cart.total_price / shipping_quotient;
          var value_left = (shippingvalue - cart.total_price) / 100;
          var value_left_money = value_left.toFixed(2);
          if(cart.item_count == 0){
              setCookie("free_shipping_animation_cookie","free_shipping_animation_cookie_below");
              document.querySelectorAll('.freeshippingstatus').forEach(function(elm){
                if( !elm.closest('.product-info-wrapper') ){
                  elm.style.display = "none";
                }else{
                  if(value_left >= 0){
                    elm.querySelector(".text").innerHTML = commonconfig.dataset.shippingstatusyouare + ' <i>'+currentCurrency+value_left_money+'</i> '+commonconfig.dataset.shippingstatusaway+' <b>'+commonconfig.dataset.shippingstatusfree+'</b>';
                    elm.querySelector('.freeshippingstatus-bg1').style.width = shipping_percent+"%";
                    elm.querySelector('.freeshippingstatus-badge').textContent = Math.floor(shipping_percent);
                    setCookie("free_shipping_animation_cookie","free_shipping_animation_cookie_below");
                  }
                }
              });
          }else{                 
                document.querySelectorAll('.freeshippingstatus').forEach(function(elm){
                elm.style.display = "block";
                if(value_left >= 0){
                  elm.querySelector(".text").innerHTML = commonconfig.dataset.shippingstatusyouare+' <i>'+currentCurrency+value_left_money+'</i> '+commonconfig.dataset.shippingstatusaway+' <b>'+commonconfig.dataset.shippingstatusfree+'</b>';
                  elm.querySelector('.freeshippingstatus-bg1').style.width = shipping_percent+"%";
                  elm.querySelector('.freeshippingstatus-badge').textContent = Math.floor(shipping_percent);
                  setCookie("free_shipping_animation_cookie","free_shipping_animation_cookie_below");
                }
                else{
                  elm.querySelector(".text").innerHTML = commonconfig.dataset.shippingstatusvaluehtml;
                  elm.querySelector('.freeshippingstatus-bg1').style.width = "100%";
                  elm.querySelector('.freeshippingstatus-badge').textContent = "100";

                  if(enableconfettianimation == "true"){
                      var free_shipping_animation_cookie = getCookie("free_shipping_animation_cookie");
                      if (free_shipping_animation_cookie === 'free_shipping_animation_cookie' ) {
                          return;
                      }
                      initConfetti();
                      render();
                      setCookie("free_shipping_animation_cookie","free_shipping_animation_cookie");
                  }
                }
              });
            }
        }        
      );  
  }else{setCookie("free_shipping_animation_cookie","free_shipping_animation_cookie_below");}
}

var commonconfig = document.getElementById("commmonconfigval");
if(commonconfig){
    var pageloader = commonconfig.dataset.pageloader;
    if(pageloader == "true"){
      document.body.classList.add('page-loading');
  }
}
/* Language and Currency Switcher Script */
function languageCurrencySwitcher(){
      const languageForm = document.querySelector('.LanguageForm');
      const langlistItems = document.querySelectorAll(".LanguageFormList li");

      langlistItems.forEach(function(item) {
        item.addEventListener("click", function() {
          const selectedlang = this.querySelector("a").getAttribute("data-value");
          this.closest(".LanguageForm").querySelector("input[name='locale_code']").value = selectedlang;
          this.closest(".LanguageForm").querySelector("input[name='return_to']").value = window.location.href;
          this.closest(".LanguageForm").submit();
        });
      });
      const currencyForm = document.querySelector('.CurrencyForm');
      const currencylistItems = document.querySelectorAll(".CurrencyFormList li");
      currencylistItems.forEach(function(item) {
        item.addEventListener("click", function() {
          const selectedcurrency = this.querySelector("a").getAttribute("data-value");
          this.closest('.CurrencyForm').querySelector("input[name='country_code']").value = selectedcurrency;
          this.closest('.CurrencyForm').querySelector("input[name='return_to']").value = window.location.href;
          this.closest('.CurrencyForm').submit();
        });
      });  

      if(document.querySelectorAll('.footer-section .CurrencyFormList, .top-infobar .CurrencyFormList')){
        const currencyFormLists = document.querySelectorAll('.footer-section .CurrencyFormList, .top-infobar .CurrencyFormList');
        function removeCurrnyActiveClass() {
          currencyFormLists.forEach((list) => {
            list.classList.remove('active');
          });
        }
        document.addEventListener('click', (event) => {
          var clickedInside = false;
          currencyFormLists.forEach((list) => {
            const button = list.closest('.localization-wrap').querySelector('.localization-selector');
            if (list.contains(event.target) || button.contains(event.target)) {
              clickedInside = true;
            }
          });
          if (!clickedInside) {
            removeCurrnyActiveClass();
          }
        });
    }
    if(document.querySelector('.footer-section .LanguageFormList, .top-infobar .LanguageFormList')){
        const LanguageFormLists = document.querySelectorAll('.footer-section .LanguageFormList, .top-infobar .LanguageFormList');
        function removeLangActiveClass() {
          LanguageFormLists.forEach((list) => {
            list.classList.remove('active');
          });
        }
        document.addEventListener('click', (event) => {
          var clickedInside = false;
          LanguageFormLists.forEach((list) => {
            const button = list.closest('.localization-wrap').querySelector('.localization-selector');
            if (list.contains(event.target) || button.contains(event.target)) {
              clickedInside = true;
            }
          });
          if (!clickedInside) {
            removeLangActiveClass();
          }
        });
    }
  
}
/* End of Language and Currency Switcher Script */

/* Customer Account Show Hide Address Form Code */
function customeractshowhide(){
    const editFormButtons = document.querySelectorAll('.customer.addresses .addressformbtn');
    if (editFormButtons.length > 0) {
        editFormButtons.forEach(function(editFormButton) {
            editFormButton.addEventListener('click', function() {
                const ariaControlsValue = this.getAttribute('aria-controls');
                const targetElement = document.getElementById(ariaControlsValue);
                if (targetElement) {
                    if (targetElement.style.display === 'none' || targetElement.style.display === '') {
                        targetElement.style.display = 'block';
                    } else {
                        targetElement.style.display = 'none';
                    }
                }
            });
        });
    }
}

/* lookbook Script */
function lookbookscript(){
  const lookbookbtns = document.querySelectorAll('.lookbook-wrapper .lookbook-button');
  if(lookbookbtns){
      lookbookbtns.forEach(lookbookbtn => {
          lookbookbtn.addEventListener('mouseenter', function () {
              document.querySelectorAll('.lookbook-wrapper .lookbook-item').forEach(item => {
                  item.classList.remove('show');
              });    
              const parentItem = this.closest('.lookbook-wrapper .lookbook-item');
              if (parentItem) {
                  parentItem.classList.add('show');
              }
          });
      });
  }
}
/* End of Lookbook Code */

/* This Script for add class for video play in product page */
function productvideoplay(){
  const buttons = document.querySelectorAll('.deferred-media-button');
  if (buttons.length > 0) {
      buttons.forEach(button => {
            button.addEventListener('click', function() {
                const deferredMediaDiv = this.closest('.deferred-media');
                if (deferredMediaDiv) {
                    deferredMediaDiv.classList.add('show');
                }
            });
        });
  }
    document.querySelectorAll('.group-products select').forEach(function(selectElement) {
        selectElement.addEventListener('change', function() {
            var selectedValue = this.value;
            var formId = this.getAttribute('form');
            form = document.querySelector('.group-products #'+formId);
            if (form) {
                var variantid = form.querySelector('input[name="id"]');
                if (variantid) {
                    variantid.value = selectedValue;
                }
            }
            const qtyinputs = document.querySelectorAll('.group-products .product-qty .list-product-qty');
              qtyinputs.forEach(qtyinput => {
                  if (qtyinput.getAttribute('form') === formId) {
                      qtyinput.setAttribute('data-productid', selectedValue);
                  }
              });
        });
    });
    document.querySelectorAll('.fbtupsell-product select').forEach(function(selectElement) {
      selectElement.addEventListener('change', function() {
          var selectedValue = this.value;
          var formId = this.getAttribute('form');
          form = document.querySelector('.fbtupsell-product #'+formId);
          if (form) {
              var variantid = form.querySelector('input[name="id"]');
              if (variantid) {
                  variantid.value = selectedValue;
              }
          }
          const qtyinputs = document.querySelectorAll('.fbtupsell-product .product-qty .list-product-qty');
          qtyinputs.forEach(qtyinput => {
              if (qtyinput.getAttribute('form') === formId) {
                  qtyinput.setAttribute('data-productid', selectedValue);
              }
          });
      });
  });
  var propopmodalbtns = document.querySelectorAll('.product-popup-modal-button');
    if(propopmodalbtns){
      propopmodalbtns.forEach(function(propopmodalbtn) {
          propopmodalbtn.addEventListener('click', function() {
              var modalId = this.getAttribute('data-modal');
              if (modalId) {
                  var modalElement = document.getElementById(modalId);
                  if (modalElement) {
                      modalElement.classList.add('active');
                      document.body.classList.add('modal-open');
                  }
              }
          });
      });
      document.querySelectorAll('.product-popup-modal-close').forEach(function(closebtn) {
        closebtn.addEventListener('click', function() {
              var modalElements = document.querySelectorAll('.product-popup-modal');
              modalElements.forEach(function(modalElement) {
                  modalElement.classList.remove('active');
                  document.body.classList.remove('modal-open');
              });  
          });
      });
    }
  }
  /* End This Script for add class for video play in product page */    

function commonscripts()
{
  
		document.addEventListener('click', function(event) {

          /* Header Icons Open and Close Method */
              var hdrIcons = document.querySelector('.hdr-icons');
              var targetElement = event.target;		  
    		  var parentAnchor = targetElement.closest('a');
    		  if(parentAnchor){
    			  if(parentAnchor.classList.contains("mobilebtmstickycart")){
    				  return;
    			  }
    		  }
    		  var isClickedInsideHdrIcons = targetElement.closest('.hdr-icons');
    		  if (!isClickedInsideHdrIcons) {
    			  var childElements = hdrIcons.querySelectorAll('*');
    			  childElements.forEach(function(element) {
    				  element.classList.remove('active');
    			  });
    		  } 

            /* Check if the click is outside the account content and the button */
    		  const accountContent = document.getElementById('accountContent');
    		  const accountButton = document.querySelector('.hdr-icon.account-icon .hdicon');
    		   if(accountContent != null && accountButton!= null ){
        		  if (!accountContent.contains(event.target) && !accountButton.contains(event.target)) {
        			if (accountContent.classList.contains('active')) {
        			  accountContent.classList.remove('active');
        			}
        		  }
              }
              /*if (!accountContent.contains(event.target) && !accountButton.contains(event.target)) {
    			if (accountContent.classList.contains('active')) {
    			  accountContent.classList.remove('active');
    			}
    		  }*/

             /* To close the Cart Drawer when click outside */  
              var cartdrawer = document.getElementById('cart-drawer');
              if (event.target.id === 'cart-drawer') {
                 /* if(document.getElementById(event.target.id)){
                    document.getElementById(event.target.id).classList.remove('active');
                  }*/
                  cartdrawer.classList.remove('active'); 
                  document.body.classList.remove('offcanvas-open');
                  
              }
    
              var filterdrawer = document.getElementById('filter-drawer');
               if (event.target.id === 'filter-drawer') {
                  filterdrawer.classList.remove('active');
                  document.body.classList.remove('offcanvas-open');
              }
    
              var searchModal = document.getElementById('search-modal');
               if (event.target.id === 'search-modal') {
                  searchModal.classList.remove('active');
                  document.body.classList.remove('search-open');
                  document.body.classList.remove('modal-open');
              }
    
    
              var stickysearchModal = document.getElementById('search-modal-stickysearch');
              if (event.target.id === 'search-modal-stickysearch') {
                  stickysearchModal.classList.remove('active');
                  document.body.classList.remove('search-open');
                  document.body.classList.remove('modal-open');
                  document.body.classList.remove('mobilebtmsticky-search-open');
              }

              /* Code for Close the Modal Windows when click outside */
              if (event.target.classList.contains('pc-modal-dialog')) {
                  var modalElements = document.querySelectorAll('.pc-modal');
                  modalElements.forEach(function(modalElement) {
                      modalElement.classList.remove('active');
                      document.body.classList.remove('modal-open');
                      if(document.querySelector(".success-compare")){
                        document.querySelector(".success-compare").innerHTML = "";
                      }
                      if(document.querySelector(".error-compare")){
                        document.querySelector(".error-compare").innerHTML = "";
                      }
                  }); 
              }  
          
		});
		
	

  	if(document.querySelectorAll('.go-top').length > 0){
      window.addEventListener("scroll", function () {
        var scrolled = window.pageYOffset;
        if (scrolled > 600) document.querySelector('.go-top').classList.add('active');
        if (scrolled < 600) document.querySelector('.go-top').classList.remove('active');
      }, false);    
      document.querySelector('.go-top').addEventListener('click', function(event) {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      });
   } 
}  

/* Define a function for handling the tab visibility change event*/
  var messages = document.querySelector('.commmonconfigval').dataset.customer_tab_notification_data.split(' | ');
  let data = {
    "messages": messages,
    "delay": 1000,
    "titleTag": document.getElementsByTagName("title")[0]
  };
  if (data.titleTag) {
    data.originalTitle = data.titleTag.innerText;
    data.isSingleMessage = data.messages.length < 2;
    data.isActive = false;
  }
  function handleTabVisibilityChange() {
    if (document.visibilityState === 'visible') {
      /* If the page is visible, clear the timer and reset the title tag*/
      if (!data.isActive) return;
      clearInterval(data.timerId);
      data.titleTag.innerText = data.originalTitle;
    } else {
      /* If the page is hidden, set the new title tag and start a timer*/
      let messageIndex = 0;
      let currentMessage = data.messages[messageIndex];
      if (data.isActive = true, data.titleTag.innerText = currentMessage, data.isSingleMessage) return;
      data.timerId = setInterval(function () {
        let nextMessage = data.messages[++messageIndex];
        if (!nextMessage) {
          messageIndex = 0;
          nextMessage = currentMessage;
        }
        data.titleTag.innerText = nextMessage;
      }, data.delay);
    }
  }


/* Start code to manage Free Shipping Bar confetti effect */
   function shippingBarConfetti(){
    const canvas1 = document.createElement("canvas");
    canvas1.classList.add("confetti");
    canvas1.classList.add("hide");
    canvas1.id = "canvas";    
    document.body.appendChild(canvas1);
    canvas = document.getElementById("canvas");
    ctx = canvas.getContext("2d");
    let confetti = [];
    const confettiCount = 300;
    const gravity = 0.5;
    const terminalVelocity = 5;
    const drag = 0.075;
    const colors = [
      { front: "red", back: "darkred" },
      { front: "green", back: "darkgreen" },
      { front: "blue", back: "darkblue" },
      { front: "yellow", back: "darkyellow" },
      { front: "orange", back: "darkorange" },
      { front: "pink", back: "darkpink" },
      { front: "purple", back: "darkpurple" },
      { front: "turquoise", back: "darkturquoise" },
    ];
    
    const requestAnimationFrame =
      window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame;
     
    const cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;       
    let myReq;  
    resizeCanvas = () => {
      canvas.width = document.documentElement.clientWidth;
      canvas.height = document.documentElement.clientHeight;
      cx = ctx.canvas.width / 2;
      cy = ctx.canvas.height / 2;
    };    
    randomRange = (min, max) => Math.random() * (max - min) + min;
    initConfetti = () => {
      canvas.classList.remove("hide");
      canvas.classList.add("show");
      canvas.width = document.documentElement.clientWidth;
      canvas.height = document.documentElement.clientHeight;
      cx = ctx.canvas.width / 2;
      cy = ctx.canvas.height / 2;      
      for (let i = 0; i < confettiCount; i++) {
        confetti.push({
          color: colors[Math.floor(randomRange(0, colors.length))],
          dimensions: {
            x: randomRange(10, 20),
            y: randomRange(10, 30),
          },
    
          position: {
            x: randomRange(0, canvas.width),
            y: canvas.height - 1,
          },
    
          rotation: randomRange(0, 2 * Math.PI),
          scale: {
            x: 1,
            y: 1,
          },
    
          velocity: {
            x: randomRange(-25, 25),
            y: randomRange(0, -50),
          },
        });
      }
    };
    
    render = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    
      confetti.forEach((confetto, index) => {
        let width = confetto.dimensions.x * confetto.scale.x;
        let height = confetto.dimensions.y * confetto.scale.y;
    
        ctx.translate(confetto.position.x, confetto.position.y);
        ctx.rotate(confetto.rotation);
    
        confetto.velocity.x -= confetto.velocity.x * drag;
        confetto.velocity.y = Math.min(
          confetto.velocity.y + gravity,
          terminalVelocity
        );
        confetto.velocity.x += Math.random() > 0.5 ? Math.random() : -Math.random();
    
        confetto.position.x += confetto.velocity.x;
        confetto.position.y += confetto.velocity.y;
    
        if (confetto.position.y >= canvas.height) confetti.splice(index, 1);
    
        if (confetto.position.x > canvas.width) confetto.position.x = 0;
        if (confetto.position.x < 0) confetto.position.x = canvas.width;
    
        confetto.scale.y = Math.cos(confetto.position.y * 0.1);
        ctx.fillStyle = confetto.scale.y > 0 ? confetto.color.front : confetto.color.back;
        ctx.fillRect(-width / 2, -height / 2, width, height);
        ctx.setTransform(1, 0, 0, 1, 0, 0);
      });
    
      if (confetti.length <= 0) {
        cancelAnimationFrame(myReq);
        canvas.classList.add("hide");
        canvas.classList.remove("show");        
      }
      myReq = requestAnimationFrame(render);
    };
    
    window.addEventListener("resize", function () {
      resizeCanvas();
    });
    
    canvas1.addEventListener("click", function () {
      cancelAnimationFrame(myReq);
      canvas.classList.add("hide");
      canvas.classList.remove("show"); 
      if(document.querySelector("#CartDrawer-Overlay")){
        document.querySelector("#CartDrawer-Overlay").click();
        document.querySelector("#CartDrawer-Overlay").dispatchEvent(new Event('click'));
      }
    });  
  }  
 
/* End code to manage Free Shipping Bar confetti effect */


function gridlistview()
{
    const productContainer = document.getElementById('ProductGridContainer');
    const buttonpreview = document.querySelectorAll('.preview');
      buttonpreview.forEach(button => {
        button.onclick = function() {
            buttonpreview.forEach(btn => btn.classList.remove('active'));
            const selectedView = this.dataset.view;
            if (selectedView === 'grid') {
              switchView('grid');
            } else {
              switchView('list'); 
            }
          this.classList.add('active');
        }
    });
    function switchView(view) {
        if (view === 'list') {
            productContainer.classList.remove("grid_view");
            productContainer.classList.add("list_view");
            setCartAttribute('view_preference', 'list');
        } else {
            productContainer.classList.remove("list_view");
            productContainer.classList.add("grid_view");
            setCartAttribute('view_preference', 'grid');
        }
    }
    function setCartAttribute(attribute, value) {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                attributes: {
                    [attribute]: value
                }
            })
        }).then(response => response.json());
    }
}
/* Global accordion script for add and remove active class */

/* Complementary Products */
document.addEventListener('click', function(event) {
    const targetElement = event.target.matches('.complementary-wrapper .accordion-title') 
        ? event.target 
        : event.target.closest('.complementary-wrapper .accordion-title');
    if (targetElement) {
        targetElement.classList.toggle('active');
        const accordionContent = targetElement.nextElementSibling;
        if (accordionContent && accordionContent.classList.contains('accordion-content')) {
            accordionContent.classList.toggle('active');
        }
    }
});
/* End of Complementary Products Code */
document.querySelectorAll('.accordion-title').forEach(item => {
    item.addEventListener('click', event => {
        const isActive = item.classList.contains('active');
        document.querySelectorAll('.accordion-title').forEach(title => title.classList.remove('active'));
        document.querySelectorAll('.accordion-content').forEach(content => content.classList.remove('active'));
        if (!isActive) {
            item.classList.add('active');
            item.nextElementSibling.classList.add('active');
        }
    });
});
/* End of accordion script */

document.addEventListener('click', event => {
    if(document.getElementById('pickup-availability-drawer')){
      if(event.target.id == "pickup-availability-drawer"){
          event.target.classList.remove('active');
          document.body.classList.remove('offcanvas-open');
      }
  }
});
  function showHideDialogbox(dialogboxId){
    
    if(document.getElementById(dialogboxId)){
      
        const chkCountryList = dialogboxId.includes("CountryList-");
        const chkLanguageList = dialogboxId.includes("LanguageList-");
        flag_chck = false;
        if(chkLanguageList || chkCountryList){
          document.querySelectorAll("."+dialogboxId).forEach(function(element) {
            if(element.classList.contains('active')){
              flag_chck = true;
            }
          });
        }
        if(document.getElementById(dialogboxId).classList.contains('active') || flag_chck){
          
          document.getElementById(dialogboxId).classList.remove('active');

          if(chkLanguageList == false && chkCountryList == false){
             document.querySelectorAll(".CountryList-localization-currency").forEach(function(element) {
                    element.classList.remove('active');
             });
             document.querySelectorAll(".LanguageList-localization-language").forEach(function(element) {
                    element.classList.remove('active');
             });
          }
          document.querySelectorAll("."+dialogboxId).forEach(function(element) {
                    element.classList.remove('active');
             });
          document.body.classList.remove('search-open');
          document.body.classList.remove('modal-open');          
          if(dialogboxId == "search-modal-stickysearch"){
            document.body.classList.remove('mobilebtmsticky-search-open');
          }
          if(dialogboxId == "cartdrawernote"){
            document.getElementById("cartdrawernotetitle").classList.remove('active');  
          }
          if(dialogboxId == "cart-drawer" || dialogboxId == "pickup-availability-drawer" || dialogboxId == "filter-drawer"){
            document.body.classList.remove('offcanvas-open');
            
          }
        }else{
          
          

            if(dialogboxId == "search-modal-stickysearch"){
              document.body.classList.add('mobilebtmsticky-search-open');
            }
          
            if(dialogboxId == "cart-drawer" || dialogboxId == "pickup-availability-drawer" || dialogboxId == "filter-drawer"){
              document.body.classList.add('offcanvas-open');
            }
            if(dialogboxId != "cart-drawer" 
               && dialogboxId != "pickup-availability-drawer" 
               && dialogboxId != "filter-drawer" 
               && dialogboxId != "accountContent" 
               && dialogboxId != "search-modal"
               && dialogboxId != "search-modal-stickysearch"
               && chkCountryList == false
               && chkLanguageList == false
              && dialogboxId != "cart-popup"
              ){
              document.body.classList.add('modal-open');
            }
            if(chkCountryList == true){
                document.querySelectorAll('.LanguageFormList').forEach(function(element) {
                  element.classList.remove('active');
                });
                document.querySelectorAll("."+dialogboxId).forEach(function(element) {
                      element.classList.remove('active');
               });
            }
           if(chkLanguageList == true){
               document.querySelectorAll('.CurrencyFormList').forEach(function(element) {
                  element.classList.remove('active');
                });
             document.querySelectorAll("."+dialogboxId).forEach(function(element) {
                      element.classList.remove('active');
               });
            }
            if(chkCountryList == false && chkLanguageList == false){
              var hdrIcons = document.querySelector('.hdr-icons');
              var childElements = hdrIcons.querySelectorAll('*');
              childElements.forEach(function(element) {
                  element.classList.remove('active');
              });
              if(dialogboxId == "search-modal" || dialogboxId == "search-modal-stickysearch"){
                document.body.classList.add('search-open');
              }

             document.querySelectorAll(".CountryList-localization-currency").forEach(function(element) {
                    element.classList.remove('active');
             });
             document.querySelectorAll(".LanguageList-localization-language").forEach(function(element) {
                    element.classList.remove('active');
             });
            }
          
          if(dialogboxId == "cartdrawernote"){
            document.getElementById("cartdrawernotetitle").classList.add('active');  
          }
          if(chkLanguageList == false || chkCountryList == false){
             document.querySelectorAll("."+dialogboxId).forEach(function(element) {
                    element.classList.remove('active');
             });
          }
          if(chkLanguageList || chkCountryList){
             document.querySelectorAll("."+dialogboxId).forEach(function(element) {
                    element.classList.add('active');
             });
          }else{
             document.getElementById(dialogboxId).classList.add('active');
          }
        } /* End If */
  } /* End if check condition */
  }
/* End of Header Icon Open and Close Method Code */

function debounce(func, timeout = 300){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}
function saveInput(){
  console.log('Saving data');
}
const processChange = debounce(() => saveInput());

class PaginationFiltersForm extends HTMLElement {
    constructor() {
      super();
      this.querySelector('a').addEventListener('click', (event) => {
        var elementBody = document.body;
        elementBody.classList ? elementBody.classList.add('loading') : elementBody.className += ' loading';
        event.preventDefault();   
          fetch(event.currentTarget.href)
                .then((response) => response.text())
                .then((responseText) => {
                  const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                  var productElement = responseHTML.querySelector('#product-grid');
                  var paginationwrapper = responseHTML.querySelector('#pagination-wrapper');
                 
                  document.querySelector('#product-grid').innerHTML = productElement.innerHTML;
                  document.querySelector('#pagination-wrapper').innerHTML = paginationwrapper.innerHTML;
               
                  if (window.Shopify && Shopify.PaymentButton) {
                    Shopify.PaymentButton.init();
                  }
                })
                .finally(() => {
                    /* Create a CompareWishlistContentLoaded event*/
                    var event;
                    var event_pagination;
                    if (typeof(window.CustomEvent) === 'function') {
                      event = new CustomEvent('CompareWishlistContentLoaded', {
                        bubbles: true
                      });
                      event_pagination = new CustomEvent('PaginationFiltersFormClicked', {
                        bubbles: true
                      });
                    } else {
                      event = document.createEvent('CustomEvent');
                      event.initCustomEvent('CompareWishlistContentLoaded', true, false, null);
                      event_pagination = document.createEvent('CustomEvent');
                      event_pagination.initCustomEvent('PaginationFiltersFormClicked', true, false, null);
                    }                    
                    document.dispatchEvent(event);
                    document.dispatchEvent(event_pagination);
                    elementBody.classList ? elementBody.classList.remove('loading') : elementBody.className += ' loading';
                    gridlistview();
                });
        window.scrollTo({
          top: window.pageYOffset + document.getElementById('ProductGridContainer').getBoundingClientRect().top - 100,
          behavior: "smooth"
        });        
      });
    }
  }

  function wishlistcomparecount(){
      var wishlist_count = 0;
      var comparelist_count = 0;
      if(localStorage.getItem('shopify-wishlist')){
        var wishlist_count = (localStorage.getItem('shopify-wishlist').split(',')).length;
      }
      if(sessionStorage.getItem('shopify-compare')){
        var comparelist_count = (sessionStorage.getItem('shopify-compare').split(',')).length;
      }
      if(document.querySelector('.product-comparelist')){
          document.querySelectorAll('.product-comparelist').forEach((item) => {
            if(item.querySelector('.count')){
             
              if(comparelist_count > 0){
                  item.classList.remove("items0");
                  item.querySelector('.count').innerHTML = comparelist_count;
                }else{
                  item.classList.add("items0");
                }
            }
          });
      }
      if(document.querySelector('.product-wishlist')){
          document.querySelectorAll('.product-wishlist').forEach((item) => {
              if(item.querySelector('.count')){
                
                if(wishlist_count > 0){
                  item.classList.remove("items0");
                  item.querySelector('.count').innerHTML = wishlist_count;
                }else{
                  item.classList.add("items0");
                }
              }
          });
      }
  } 
  /*wishlistcomparecount();*/
  class Wishlistcompare {	  
        selectors_CW;      
        constructor(selectors_CW) {
          this.selectors_CW = selectors_CW;
          document.addEventListener('CompareWishlistContentLoaded', (event) => {
            this.initButtons_C();             
          });
           document.addEventListener('PaginationFiltersFormClicked', (event) => {
              this.initButtons_C();
           });
          document.addEventListener('AjaxPaginationCalled', (event) => {
              this.initButtons_C();
          });
          document.addEventListener('renderProductCount', (event) => {
              this.initButtons_C();
          });
        }
        fetchProductCardHTML_C(handle){
          let activeLocale = Shopify.locale;
          
          let productTileTemplateUrl;
          if(window.location.href.indexOf("/"+activeLocale) == -1){
            productTileTemplateUrl = `/products/${handle}?view=`+this.selectors_CW.viewlist;
          }else{
            productTileTemplateUrl = `/${activeLocale}/products/${handle}?view=`+this.selectors_CW.viewlist;
          }
          return fetch(productTileTemplateUrl)
          .then((res) => res.text())
          .then((res) => {
            const text = res;
            const parser = new DOMParser();
            const htmlDocument = parser.parseFromString(text, 'text/html');
            const productCard = htmlDocument.documentElement.querySelector(this.selectors_CW.productCard);

            return productCard.outerHTML;
          })
          .catch((err) => console.error('[Shopify Wishlist] Failed to load content for handle: '+handle, err));
        }

        formatGrid_C(productresponses)
        {
          let html = "";
          if(productresponses.length > 0) {
			if(this.selectors_CW.viewlist === "compare"){
				document.getElementById('popup-modal-compare').classList.remove("compare-items-empty"); 
			}else{
				document.getElementById('popup-modal-compare').classList.remove("wishlist-items-empty");
			} 
			html = '<ul id="main-collection-product-grid" class="product-grid pc-row pc-row-cols-xl-4 pc-row-cols-lg-3 pc-row-cols-2 list-unstyled">';
            if(this.selectors_CW.viewlist === "compare"){
              html += '<li class="product-item item-title"><div class="card-wrapper"><div class="card card-product"><div class="card-media tlt">Features</div><div class="card-content"><div class="product-title tlt">Product name</div><div class="price tlt">Price</div><div class="product-rating tlt"></div><div class="product-card-addtocart"><div class="compare-options tlt">Options</div><div class="product-form-qty tlt">&nbsp;</div><div class="product-form-submit tlt">Action</div></div></div></div></div></li>';            
            }
            productresponses.forEach(product => {
               if(typeof product !== "undefined"){
                  let htmlSegment = '<li class="product-item">'+product+'</li>';
                  html += htmlSegment;
               }
            });
            html += "</ul>";
          } else { 
			if(this.selectors_CW.viewlist === "compare"){
				document.getElementById('popup-modal-compare').classList.add("compare-items-empty"); 
				document.getElementById('popup-modal-compare').classList.remove("wishlist-items-empty"); 
			}else{
				document.getElementById('popup-modal-compare').classList.add("wishlist-items-empty");
				document.getElementById('popup-modal-compare').classList.remove("compare-items-empty");
			} 
            document.querySelector(".error-compare").innerHTML = "<span>"+this.selectors_CW.empty+"</span>";
          }
          return html;
        };

        async setupGrid_C(grid){
          const comparelist = this.getComparelist_C();
          const requests = comparelist.map(this.fetchProductCardHTML_C.bind(this));
          const responses = await Promise.all(requests);
          const compareProductCards = this.formatGrid_C(responses);
          grid.innerHTML = compareProductCards;
          grid.classList.add(this.selectors_CW.GRID_LOADED_CLASS_C);

          /* Create a CompareWishlistContentLoaded event*/
          var event;
          if (typeof(window.CustomEvent) === 'function') {
            event = new CustomEvent('CompareWishlistContentLoaded', {
              bubbles: true
            });
          } else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent('CompareWishlistContentLoaded', true, false, null);
          }
          /* Dispatch the render event*/
          document.dispatchEvent(event);
          /* this.initButtons_C();*/
          document.querySelector(".heading-compare").innerHTML = this.selectors_CW.Heading;
          modal_C.querySelector('.modal-content-compare').classList.remove("modalcw-compare");
          modal_C.querySelector('.modal-content-compare').classList.remove("modalcw-wishlist");
          modal_C.querySelector('.modal-content-compare').classList.add("modalcw-" + this.selectors_CW.viewlist);
		  modal_C.classList.add("active");
		  document.body.classList.add('modal-open');
          this.onchangevariantcompare();
			qtyincdec();
			productvariantscript();
			addtocartbtnevent();
        };
        setupButtons_C(buttons){
          var buttoncomparelist = buttons; 
          for(var i =0; i< buttoncomparelist.length; i++){
            buttoncomparelist[i].onclick = function(event){
              event.preventDefault();
              let currentelement = event.currentTarget;
			  addTemporaryClass(currentelement, 'loading', 2000);			  
              const productHandle = currentelement.dataset.productHandle || false;
              const productTitle = currentelement.dataset.productTitle || false;
              this.updateComparelist_C(productHandle);
              if (!productHandle) 
                return console.error('[Shopify Comparelist] Missing `data-product-handle` attribute. Failed to update the '+this.selectors_CW.Heading+'.');
              if (this.comparelistContains_C(productHandle)) { 
                currentelement.classList.add(this.selectors_CW.BUTTON_ACTIVE_CLASS_C);
                this.initGrid_C();
                document.querySelector(".success-compare").classList.remove("removed-compare");
                document.querySelector(".success-compare").innerHTML =  "<span>"+productTitle+" "+this.selectors_CW.added+"</span>";
              } else {
                currentelement.classList.remove(this.selectors_CW.BUTTON_ACTIVE_CLASS_C);
                document.querySelector(".success-compare").classList.add("removed-compare");
                document.querySelector(".success-compare").innerHTML =  "<span>"+productTitle+" "+this.selectors_CW.removed+"</span>";
                if(currentelement.closest(this.selectors_CW.grid)) {
                  currentelement.closest('li').remove();
                }else{
                  this.initGrid_C();
                }
                const comparelist = this.getComparelist_C();
                if(comparelist.length <= 0){				
					if(this.selectors_CW.viewlist === "compare"){
						document.getElementById('popup-modal-compare').classList.add("compare-items-empty"); 
						document.getElementById('popup-modal-compare').classList.remove("wishlist-items-empty"); 
					}else{
						document.getElementById('popup-modal-compare').classList.add("wishlist-items-empty");
						document.getElementById('popup-modal-compare').classList.remove("compare-items-empty");
					} 				
                  document.querySelector(".modal-text-compare").innerHTML = "";
                  document.querySelector(".error-compare").innerHTML = "<span>"+this.selectors_CW.empty+"</span>";
                }
              }

              /* Create a CompareWishlistContentLoaded event*/
              var event;
              if (typeof(window.CustomEvent) === 'function') {
                event = new CustomEvent('CompareWishlistContentLoaded', {
                  bubbles: true
                });
              } else {
                event = document.createEvent('CustomEvent');
                event.initCustomEvent('CompareWishlistContentLoaded', true, false, null);
              }
              /* Dispatch the render event*/
              document.dispatchEvent(event);
            }.bind(this);
          }
          for(var i =0; i< buttoncomparelist.length; i++){
            const productHandle = buttoncomparelist[i].dataset.productHandle || false;
            if (this.comparelistContains_C(productHandle)) { 
              buttoncomparelist[i].classList.add(this.selectors_CW.BUTTON_ACTIVE_CLASS_C);
            }else{
              buttoncomparelist[i].classList.remove(this.selectors_CW.BUTTON_ACTIVE_CLASS_C);
            }
          }
        };
        initGrid_C(){
          const grid = document.querySelector(this.selectors_CW.grid) || false;
          if (grid) this.setupGrid_C(grid);
        };

        initButtons_C(){
          const buttons = document.querySelectorAll(this.selectors_CW.button) || [];
          if (buttons.length) this.setupButtons_C(buttons);
          else return;
          const event = new CustomEvent('shopify-comparelist:init-buttons', {
            detail: { comparelist: this.getComparelist_C() }
          });
          document.dispatchEvent(event);		  
        };
        getComparelist_C(){
          const comparelist = this.selectors_CW.STORAGETYPE.getItem(this.selectors_CW.LOCAL_STORAGE_KEY_C) || false;
          if (comparelist){   
            return comparelist.split(this.selectors_CW.LOCAL_STORAGE_DELIMITER_C).reverse();
          }
          return [];
        };
        setComparelist_C(array){
          const comparelist = array.join(this.selectors_CW.LOCAL_STORAGE_DELIMITER_C);
          if (array.length) this.selectors_CW.STORAGETYPE.setItem(this.selectors_CW.LOCAL_STORAGE_KEY_C, comparelist);
          else this.selectors_CW.STORAGETYPE.removeItem(this.selectors_CW.LOCAL_STORAGE_KEY_C);
          const event = new CustomEvent('shopify-comparelist:updated', {
            detail: { comparelist: array }
          });
          document.dispatchEvent(event);
          return comparelist;
        };
        updateComparelist_C(handle){
          const comparelist = this.getComparelist_C();
          const indexInComparelist = comparelist.indexOf(handle);
          if (indexInComparelist === -1) comparelist.push(handle);
          else comparelist.splice(indexInComparelist, 1);
          return this.setComparelist_C(comparelist);
        };
        comparelistContains_C(handle){
          const comparelist = this.getComparelist_C();
          return comparelist.includes(handle);
        };
        resetComparelist_C(){
          return this.setComparelist_C([]);
        };
        onchangevariantcompare(){          
          let selectvariants = document.querySelector(this.selectors_CW.grid).querySelectorAll(".select-select");
    	  selectvariants.forEach(el => el.addEventListener('click', event => {
            event.preventDefault();
          }));
          selectvariants.forEach(el => el.addEventListener('change', event => {            
            event.preventDefault();
            var formobj = event.target.closest("form");            
            var optioncount = parseInt(formobj.querySelector("input[name=optionscounts]").value);
            var tempproductid = "";
            var stringproductid = "";
            for(var i=0 ;i < optioncount; i++){
              tempproductid = formobj.querySelector('.compare-products-options-'+i+' option:checked').value;
              if (i < optioncount){
                if(i != optioncount-1){
                  stringproductid += tempproductid + "/";}
                else{	
                  stringproductid += tempproductid 
                }
              }
            }
            for (const option of formobj.querySelector(".product-form-variants")) {             
              if(option.text.replace(/\s+/g, "") == stringproductid){
                formobj.querySelector('input[name=id]').value = option.value;                
              }
            }
          }));         
        }
  } /* class end */
  
    function addTemporaryClass(button, className, duration) {
		button.classList.add(className);
		setTimeout(function() {
			button.classList.remove(className);
		}, duration);
    }
    const selectors_Compare = {
      button: '[button-comparelist]',
      grid: '[grid-comparelist]',
      productCard: '.card-wrapper',
      LOCAL_STORAGE_KEY_C:  'shopify-compare',
      LOCAL_STORAGE_DELIMITER_C: ',',
      BUTTON_ACTIVE_CLASS_C: 'active',
      GRID_LOADED_CLASS_C: 'loaded',
      STORAGETYPE: sessionStorage,
      viewlist: 'compare',
      Heading: window.headercomparelist,
      added:  window.comparelistadded,
      removed: window.comparelistremoved,
      empty: window.comparelistempty,
    };
  
    const selectors_Wishlist = {
      button: '[button-wishlist]',
      grid: '[grid-wishlist]',
      productCard: '.card-wrapper',
      LOCAL_STORAGE_KEY_C:  'shopify-wishlist',
      LOCAL_STORAGE_DELIMITER_C: ',',
      BUTTON_ACTIVE_CLASS_C: 'active',
      GRID_LOADED_CLASS_C: 'loaded',
      STORAGETYPE: localStorage,
      viewlist: 'wishlist',
      Heading: window.headerwishlist,
      added: window.wishlistadded,
      removed: window.wishlistremoved,
      empty: window.wishlistempty,    
    };
    let wishlist =  new Wishlistcompare(selectors_Wishlist);
    let comparelist =  new Wishlistcompare(selectors_Compare);
  
  	  var product_wishlist_button = document.querySelectorAll(".product-wishlist");
   	  if(product_wishlist_button){
        product_wishlist_button.forEach(el => el.addEventListener('click', event => {
          wishlist.initGrid_C();
        }));
      }  
      var product_comparelist_button = document.querySelectorAll(".product-comparelist");
  	  if(product_comparelist_button){
        product_comparelist_button.forEach(el => el.addEventListener('click', event => {
          comparelist.initGrid_C();
        }));
     }
	  document.querySelector(selectors_Wishlist.grid).addEventListener( 'click', function( e ) {
        e.stopImmediatePropagation();
        if(typeof e.target.className !== 'object' && e.target.className !== null && e.target.closest('button')){
            if(e.target.closest('button').className.indexOf("product-form-submit") != -1 || e.target.closest('button').className.indexOf("product-chooseoptions") != -1){
              setTimeout(function(){ 
                document.getElementById('popup-modal-compare').style.display = "none";
              }, 1000); 
            } else {
            
            }
        }
      });
  
      document.querySelector(selectors_Compare.grid).addEventListener( 'click', function( e ) {
        e.stopImmediatePropagation();
         if(typeof e.target.className !== 'object' && e.target.className !== null && e.target.closest('button')){
            if(e.target.closest('button').className.indexOf("product-form-submit") != -1){
              setTimeout(function(){ 
                document.getElementById('popup-modal-compare').style.display = "none";
              }, 1000); 
            } else {

            }
         }
      });
    
      document.addEventListener('CompareWishlistContentLoaded', (event) => {
        setTimeout(function(){ 
      	  equalize_init_compare();
          }, 500);
         wishlistcomparecount();
         AjaxCallbackEvent();
      });
      document.addEventListener('QuickViewLoaded', (event) => {
         comparelist.initButtons_C();
         wishlist.initButtons_C();
      });    
       document.addEventListener('productTooltips', (event) => {
           chooseoptpopup();
      });
 
      var modal_C = document.getElementById('popup-modal-compare');
      var btn_C = document.getElementsByClassName("product-comparelist")[0];
      var span_C = document.getElementsByClassName("modal-close-compare")[0];
     
      span_C.onclick = function(event) {
		modal_C.classList.remove("active");
		document.body.classList.remove('modal-open');
        document.querySelector(".success-compare").innerHTML = "";
        document.querySelector(".error-compare").innerHTML = "";
        document.querySelector(selectors_Compare.grid, selectors_Wishlist.grid).innerHTML = "";
      };

      window.addEventListener('click', function(event) {
        if (event.target == modal_C) {
		  modal_C.classList.remove("active");
		  document.body.classList.remove('modal-open');
          document.querySelector(".success-compare").innerHTML = "";
          document.querySelector(".error-compare").innerHTML = "";
          document.querySelector(selectors_Compare.grid, selectors_Wishlist.grid).innerHTML = "";
        }
      });

function chooseoptpopup(){	
	const buttons = document.querySelectorAll('.product-chooseoptions:not(.listening)');
	var section_id = "quickadd";
	var handleName = "quickadd";
    buttons.forEach(function(button) {
      button.classList.add('listening');
        button.addEventListener('click', function(event) {
			event.stopImmediatePropagation();
			button.classList.add("loading");
			const producturl = button.getAttribute("data-product-url") + "?section_id="+section_id ;
			const producthandle = button.getAttribute("data-product-handle");
				  return fetch(producturl)
				  .then((res) => res.text())
				  .then((res) => {
					var modelId = document.getElementById("chooseoptionModal");
					modelId.classList.add("active"); 
					document.body.classList.add('modal-open');
					button.classList.remove("loading");					
					const productCard = document.querySelector('.quickshop-chooseoptions') || false;
					var htmlset_flag = setInnerHtml(productCard,res);
					if(modelId.querySelector('variant-radios,variant-selects')){
					  modelId.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
					}					
					if (Shopify.PaymentButton) {
					  Shopify.PaymentButton.init();
					}
					if (window.ProductModel) window.ProductModel.loadShopifyXR();
					var event;
					if (typeof(window.CustomEvent) === 'function') {
					  event = new CustomEvent('CompareWishlistContentLoaded', {
						bubbles: true
					  });
					} else {
					  event = document.createEvent('CustomEvent');
					  event.initCustomEvent('CompareWishlistContentLoaded', true, false, null);
					}

					/* Dispatch the render event*/
					document.dispatchEvent(event);
					
					/* Function for initialize swiper function available in pocotheme.js */
					
				  })
				  .catch((err) => console.error('[Shopify '+handleName+'] Failed to load content for handle: '+producthandle, err))
                  .finally(() => {
                   AjaxCallbackEvent();
                  });
                    
        });
    });
}

function quickviewpopup(){	
	const buttons = document.querySelectorAll('.product-quickview:not(.listening)');
	var section_id = "quickview";
	var handleName = "quickview";
    buttons.forEach(function(button) {
      button.classList.add('listening');
        button.addEventListener('click', function(event) {
			event.stopImmediatePropagation();
			button.classList.add("loading");
			const producturl = button.getAttribute("data-product-url") + "?section_id="+section_id ;
			const producthandle = button.getAttribute("data-product-handle");
				  return fetch(producturl)
				  .then((res) => res.text())
				  .then((res) => {
					var modelId = document.getElementById("quickviewModal");
					modelId.classList.add("active"); 
					button.classList.remove("loading");	
					document.body.classList.add('modal-open');
					const productCard = document.querySelector('.quickshop-view') || false;
					var htmlset_flag = setInnerHtml(productCard,res);
					if(modelId.querySelector('variant-radios,variant-selects')){
					  modelId.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
					}					
					if (Shopify.PaymentButton) {
					  Shopify.PaymentButton.init();
					}
					if (window.ProductModel) window.ProductModel.loadShopifyXR();
					var event;
					if (typeof(window.CustomEvent) === 'function') {
					  event = new CustomEvent('CompareWishlistContentLoaded', {
						bubbles: true
					  });
					} else {
					  event = document.createEvent('CustomEvent');
					  event.initCustomEvent('CompareWishlistContentLoaded', true, false, null);
					}

					/* Dispatch the render event*/
					document.dispatchEvent(event);
					
					/* Function for initialize swiper function available in pocotheme.js */
                   
				  })
				  .catch((err) => console.error('[Shopify '+handleName+'] Failed to load content for handle: '+producthandle, err))
                  .finally(() => {
                     AjaxCallbackEvent();
                  });			
        });
    });
}
  
  function setInnerHtml(elm, html) {
    elm.innerHTML = html;
    Array.from(elm.querySelectorAll("script")).forEach(oldScript => {
      const newScript = document.createElement("script");
      Array.from(oldScript.attributes)
        .forEach(attr => newScript.setAttribute(attr.name, attr.value));
      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
    return true;
  }

  function equalizeHeightsByRow(selector,childitem) {
    const rows = document.querySelectorAll(selector);
    rows.forEach(row => {
      const elements = row.querySelectorAll(childitem);
      let maxHeight = 0;
      elements.forEach(element => {
        const height = element.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });
      elements.forEach(element => {
        element.style.height = maxHeight + 'px';
      });
    });
  }

  function equalize(sel) {
  equalizeHeightsByRow('.product-item', '.product-title');
  return;  
      var els = Array.prototype.slice.call(document.querySelectorAll(sel));  
      var row = [];
      var max;
      var top;
      var ratingheight = false;
      if(sel === ":scope .product-grid .product-rating"){
         for (var i=0; i < els.length; i++) {
           if(!(els[i].childNodes.length > 1)){
                els[i].innerHTML = "&nbsp;";
             }
         }
      } 
      function setHeights() {
        row.forEach(function(e) {
          e.style.transition = "transform 1s ease-out";
          e.style.height = max + 'px';
        });
      }
      function setRowHeights(){
      	    if(sel === ":scope .product-grid .product-rating"){
             for (var j=0; j < row.length; j++) {
               if(ratingheight) break;
               if(row[j].childNodes.length > 1){
                 ratingheight = true 
               }
             }
             if(!ratingheight){
               row.forEach(function(e) {
                 e.innerHTML = "";
               });
             }
          }
      }
      for (var i=0; i < els.length; i++) {
        var el = els[i];
        var elmTop = el.getBoundingClientRect().top;
        el.style.height = 'auto';
        if(i === 0){
          top = elmTop;
        }
       if (elmTop > top) {
      
           setHeights();
    	   setRowHeights();          
           top = elmTop;      
           max = 0;
           row = [];
           ratingheight = false;
        }
        row.push(el);
        max = Math.max(max, el.offsetHeight);
          if (i === els.length - 1) {
            setHeights();
            setRowHeights();
          }
      }
    }   
  function equalize_compare(sel) {      
      var els = Array.prototype.slice.call(document.querySelectorAll(sel));  
      var row = [];
      var max = 0;
      var top;
      var ratingheight = false;
      function setHeights() {
        row.forEach(function(e) {
          e.style.transition = "transform 1s ease-out";
          e.style.height = max + 'px';
        });
      }
      for (var i=0; i < els.length; i++) {
        var el = els[i];
        var elmTop = el.getBoundingClientRect().top + window.scrollY;
        el.style.height = 'auto';
        row.push(el);
        max = Math.max(max, el.offsetHeight);
      }
    
      setHeights(); /* last row */
    }
  
  function equalize_init(){ 
    return true;
    equalizeHeightsByRow('.product-item', '.card-wrapper');
    equalizeHeightsByRow('.product-item', '.card');
    equalizeHeightsByRow('.product-item', '.card-content');
    equalizeHeightsByRow('.product-item', '.product-title');
    equalizeHeightsByRow('.product-item', '.price');
    equalizeHeightsByRow('.product-item', '.product-rating');  
    equalizeHeightsByRow('.product-item', '.compare-options');
    equalizeHeightsByRow('.product-item', '.product-form-qty'); 
    equalizeHeightsByRow('.product-item', '.product-form-submit');  
    equalizeHeightsByRow('.product-item', '.quick-add-submit'); 
  }
  
  function equalize_init_compare(){ 
    equalize_compare(':scope .modalcw-compare .card-media');
    equalize_compare(':scope .modalcw-compare .product-title');
    equalize_compare(':scope .modalcw-compare .price');
    equalize_compare(':scope .modalcw-compare .product-rating');
    equalize_compare(':scope .modalcw-compare .compare-options');
    equalize_compare(':scope .modalcw-compare .product-form-qty');
    equalize_compare(':scope .modalcw-compare .product-form-submit');
    equalize_compare(':scope .modalcw-compare .quick-add-submit');
  }
    document.addEventListener('PaginationFiltersFormClicked', (event) => {
        AjaxCallbackEvent();
    });

    document.addEventListener('GridViewListView', (event) => {
      equalize_init();
      if(typeof AOS !== 'undefined'){
         AOS.refresh();
      }
    });

   class PartsFinder {
      constructor() {
        var wasExecuted = false;
        let headerpf = document.querySelector(".header-partsFinder");
        if(headerpf){
		  headerpf.addEventListener('click', event => {
            if (wasExecuted) {
              return;
            }
            wasExecuted = true;
            headerpf.querySelector(".select-select").focus();
          });
        }
        let parffinderobj = document.querySelectorAll(".product-part-finder");
        for (var i = 0; i < parffinderobj.length; i++) {
        	var currentobj = parffinderobj[i];
 		     let selectPartFinder = currentobj.querySelectorAll(".select-select");
             selectPartFinder.forEach(el => el.addEventListener('change', event => {
			
              var elem = (typeof el.selectedIndex === "undefined" ? window.event.srcElement : el);
              var value = elem.value || elem.options[elem.selectedIndex].value;
              var attrclass = elem.options[elem.selectedIndex].getAttribute('class');

              if(event.target.classList.contains('top-menu-index')){
                let dd2 = el.closest(".product-part-finder").querySelector(".sub-menu-index");
                let dd3 = el.closest(".product-part-finder").querySelector(".sub-sub-menu-index");
               
                this.removeppddopt(dd2);
                this.removeppddopt(dd3);
                this.fetchfiltermenu(dd2, "."+elem.getAttribute('data-menu-index')+"-"+elem.selectedIndex);
              }

              if(event.target.classList.contains('sub-menu-index')){
                let dd3 = el.closest(".product-part-finder").querySelector(".sub-sub-menu-index");
                this.removeppddopt(dd3);
                this.fetchfiltermenu(dd3,"."+ attrclass+"-"+elem.getAttribute('data-menu-index')+"-"+elem.selectedIndex);
              }
            }));  
            let PartFinderButton = currentobj.querySelector(".finderbutton");
            PartFinderButton.addEventListener('click', event => {
			  var dd1 = event.target.closest(".product-part-finder").querySelector(".top-menu-index");	
              var dd2 = event.target.closest(".product-part-finder").querySelector(".sub-menu-index");
              var dd3 = event.target.closest(".product-part-finder").querySelector(".sub-sub-menu-index");
              var commonconfigval = document.getElementById("commmonconfigval"); 
              var makealertlbl = commonconfigval.dataset.makealertlbl;
              var modelalertlbl = commonconfigval.dataset.modelalertlbl;
              var yearlertlbl = commonconfigval.dataset.yearlertlbl;
              
              if(dd1.options[dd1.selectedIndex].value === "Make"){
              	alert(makealertlbl);
                return false;
              } else if(dd2.options[dd2.selectedIndex].value === "Modal"){
              	alert(modelalertlbl);
                return false;
              } else if(dd3.options[dd3.selectedIndex].value === "Year"){
                alert(yearlertlbl);
                return false;
              } else {
                window.location.href = dd3.options[dd3.selectedIndex].value;
              } 	
            });          
        }            
      }

      async fetchfiltermenu(dd, selector){
        const productTileTemplateUrl = '/?section_id=main-collection-filters-menu-dd';
        return await fetch(productTileTemplateUrl)
        .then((res) => res.text())
        .then((res) => {
          const text = res;
          const parser = new DOMParser();
          const htmlDocument = parser.parseFromString(text, 'text/html');
          const ddbox = htmlDocument.documentElement.querySelectorAll(selector);
          let optlist = "";
          for (var i = 0, len = ddbox.length; i < len; i++) {
            dd.append(ddbox[i]);
          }
        })
        .catch((err) => console.error('[Shopify Filter Menu] Failed to load content for handle:', err));
      }

      removeppddopt(dd){
        for (var i = 1; i < dd.length; i++) {
          dd.removeChild(dd.options[i]);
          i--; /* options have now less element, then decrease i*/
        }
      }
    }




 function productSwatches(){
    document.querySelectorAll('.prod_swatch:not(.listening)').forEach((item) => {
      item.classList.add('listening');
      var ori_img = "";
      var img_flag = false;
      item.addEventListener('mouseover', (event) => {
        event.stopImmediatePropagation(); 
        
        var variant_image = event.target.dataset.variantImage;
        if(variant_image){
          if(item.closest(".card").querySelectorAll(".media > img")[1].src != null){
            img_flag = true;
            ori_img = item.closest(".card").querySelectorAll(".media > img")[1].srcset;
            item.closest(".card").querySelectorAll(".media > img")[1].srcset = variant_image;
          } else {
            img_flag = false;
            ori_img = item.closest(".card").querySelectorAll(".media > img")[0].srcset;
            item.closest(".card").querySelectorAll(".media > img")[0].srcset = variant_image;
          }
        }
      });
      item.addEventListener('mouseout', (event) => {
        event.stopImmediatePropagation(); 
        var variant_image =  event.target.dataset.variantImage;
        if(variant_image){
          if(img_flag){
            item.closest(".card").querySelectorAll(".media > img")[1].srcset = ori_img;
          } else {
            img_flag = false;
            item.closest(".card").querySelectorAll(".media > img")[0].srcset = ori_img;
          }
        }
      });
    });
  }
  
 function PopUp(hideOrshow, element) {
    if (hideOrshow == 'hide') {
      element.classList.remove('active');
	  document.body.classList.remove('modal-open');
    } else {
      element.classList.add('active');
	  document.body.classList.add('modal-open');
    }
  }

  function PopUpInitialize(element,apparitiondelay,closedelay,show_only_once_popup) { 
    setTimeout(function () {
    
      if(show_only_once_popup && !sessionStorage.getItem(element)){
      	PopUp('show',element);
        sessionStorage.setItem(element, true);
        
      } else {
        if(!show_only_once_popup && !sessionStorage.getItem(element)){
        	PopUp('show',element);
     
        sessionStorage.removeItem(element);
        }
      }
    }, apparitiondelay);

    if(closedelay > 0){
      setTimeout(function () {
        PopUp('hide',element);
      }, closedelay);            
    }

    /* Get the <span> element that closes the modal*/

    var close_Popup = element.querySelector(".popup-close");
    /* When the user clicks on <span> (x), close the modal*/
    close_Popup.onclick = function() {
      
      PopUp('hide',element);
    };

    var nPopup = element.querySelector("#nPopup");
    
    element.addEventListener('click', (event) => {
      if(event.composedPath()[0].id == "ac-wrapper"){
        PopUp('hide',element);
      }
      if(event.composedPath()[0].classList.contains('popup-content')){
        PopUp('hide',element);
      }
      if(event.composedPath()[0].id == "nPopup"){
        var nPopup = element.querySelector("#nPopup");
     
        if(nPopup.checked || show_only_once_popup){
          sessionStorage.setItem(element, true);
        } else {
          sessionStorage.removeItem(element);
        }
      }
    });
  }

 function countdowntimer(productid,sectionid,countdowntimer_date){
    var second = 1000, 
        minute = second * 60, 
        hour = minute * 60, 
        day = hour * 24; 
  
    var countDown = new Date(countdowntimer_date).getTime();
    var now = new Date().getTime();
    distance = countDown - now;
  	if(distance > 0){
         x = setInterval(function() { 
          var now = new Date().getTime(), 
              distance = countDown - now;
           
            document.querySelectorAll(".countdowntimer_"+sectionid+"_"+productid).forEach((item) => {                                            
               if(item){
                   item.classList.replace('no-js', 'temp'),
                   item.querySelector('.js-timer-days').innerText = Math.floor(distance / (day)), 
                   item.querySelector('.js-timer-hours').innerText = Math.floor((distance % (day)) / (hour)),     
                   item.querySelector('.js-timer-minutes').innerText = Math.floor((distance % (hour)) / (minute)), 
                   item.querySelector('.js-timer-seconds').innerText = Math.floor((distance % (minute)) / second); 
               }
            });
        }, second); 
    } else {
       document.querySelectorAll(".countdowntimer_"+sectionid+"_"+productid).forEach((item) => {
        if(item != null)
        	item.parentNode.removeChild(item); 
      });
    }  
  }

  
  function updateSKU(input_sku, myJSON) {
      var jsonData = JSON.parse(myJSON);
      var sku;
      for (var i = 0; i < jsonData.variants.length; i++) {
        var counter = jsonData.variants[i];
        if(counter.id == input_sku){  
          sku = counter.sku;
          break;              
        }
      } 
      return sku;             
  }

  function updateValue(event,input_sku,myJSON,config) 
  {    
        event.stopImmediatePropagation();
        var jsonData = JSON.parse(myJSON);
        var text,color,width;
        /* Access the config values*/
        const low_stock_count = config.low_stock_count;
        const text_stock_none = config.text_stock_none;
        const width_stock_none = config.width_stock_none;
        const color_stock_none = config.color_stock_none;
        const text_stock_low = config.text_stock_low;
        const width_stock_low = config.width_stock_low;
        const color_stock_low = config.color_stock_low;
        const text_stock_normal = config.text_stock_normal;
        const width_stock_normal = config.width_stock_normal;
        const color_stock_normal = config.color_stock_normal; 
        var commonconfigval = document.getElementById("commmonconfigval");
        var instocklbl = commonconfigval.dataset.instocklbl
    
        for (var i = 0; i < jsonData.variants.length; i++) {
          var counter = jsonData.variants[i];
          if(counter.id == input_sku){
            if(counter.inventory_quantity == 0 && counter.available == "true")
            {
              text = instocklbl;
              color = color_stock_normal;
              width = width_stock_normal;
            }else if(counter.inventory_quantity <= 0 && counter.available == "true")
            {
              text = instocklbl;
              color = color_stock_normal;
              width = width_stock_normal;
            }else if(counter.inventory_quantity <= 0 && counter.available == "false"){
              text = text_stock_none;
              color = color_stock_none;
              width = width_stock_none;
            } else if(counter.inventory_quantity <= parseInt(low_stock_count)){
              text = text_stock_low.replace("(count)", counter.inventory_quantity);
              color = color_stock_low;
              width = width_stock_low;
            } else {
              text = text_stock_normal.replace("(count)", counter.inventory_quantity);
              color = color_stock_normal;
              width = width_stock_normal;
            }
            break;              
          }
        }  
      if(event.target.closest('.product-info-wrapper').querySelector('.lowstockindicator span')){
          event.target.closest('.product-info-wrapper').querySelector('.lowstockindicator span').innerHTML = text;
          event.target.closest('.product-info-wrapper').querySelector('.lowstockindicator-bg1').style.backgroundColor = color;
          event.target.closest('.product-info-wrapper').querySelector('.lowstockindicator-bg1').style.width = width+"%";
      }
    }

  function updateButtonNotifyMe(event,input_sku,myJSON) 
  {
    
      var jsonData = JSON.parse(myJSON);
      var flag_check_stock;    
      for (var i = 0; i < jsonData.variants.length; i++) {
        var counter = jsonData.variants[i];
        if(counter.id == input_sku){
 
          if(counter.available == "false")
          {
            
            flag_check_stock = 1;
            if (event.target && event.target.closest) {
                if(event.target.closest('.product-info-wrapper , .sticky-addtocart-bar-form')){
                  if(event.target.closest('.product-info-wrapper') != null){ 
                     event.target.closest('.product-info-wrapper').querySelector('.nofitifymebackinstockbutton').classList.add("show");
                  }
                  if(event.target.closest('.sticky-addtocart-bar-form') != null){
                    event.target.closest('.sticky-addtocart-bar-form').querySelector('.nofitifymebackinstockbutton').classList.add("show"); 
                  }
                }
            }
            break;
          }else{
            flag_check_stock = 0;
          } 
                        
        }
      }
      if(flag_check_stock == 0){

        if (event.target && event.target.closest) {
            if(event.target.closest('.product-info-wrapper , .sticky-addtocart-bar-form')){
              if(event.target.closest('.product-info-wrapper') != null){
                event.target.closest('.product-info-wrapper').querySelector('.nofitifymebackinstockbutton').classList.remove("show");
              }
              if(event.target.closest('.sticky-addtocart-bar-form') != null){
                event.target.closest('.sticky-addtocart-bar-form').querySelector('.nofitifymebackinstockbutton').classList.remove("show");
              }
            }
        }
      }
  }


function preload(url) {
  let images = new Image();
  images.src = url;
}  
	  
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/* Function to generate a random integer between min and max (inclusive)*/
function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function findRowIndex(array2D, column, searchValue) {
  for (var i = 0; i < array2D.length; i++) {
    if (array2D[i][column] === searchValue) {
      return i;
    }
  }
  return -1;
}

function getMinutesBetweenDates(startDate, endDate) {
  const diffInMilliseconds = Math.abs(startDate - endDate);
  const minutes = Math.floor(diffInMilliseconds / (1000 * 60));
  return minutes;
}

/* Function to display a sales notification message with location, product URL, and product image, with smooth slide in and slide out effect*/
function showSalesNotification() {
  const notification = document.querySelectorAll('.sales-notification');
  if(notification.length < 1){
    return;
  }
  /* Select the notification elements*/
  let currentIndex = getRandomInt(0, notification.length - 1);
  const salesNumber = notification[currentIndex].querySelector('.sales-number');
  const location = notification[currentIndex].querySelector('.location');
  const sales_notification_locations = document.querySelector('.contentSalesNotification').dataset.location_data.split(' | ');
  /* Generate a random product object, number of sales, and location*/
  const sales = getRandomInt(1, 60);
  const loc = sales_notification_locations[getRandomInt(0, sales_notification_locations.length - 1)];

   var sales_notification_cookie = getCookie("sales_notification_cookie");
  if (sales_notification_cookie === 'close_notification') {
    notification.classList.add('hide');
    return;
  }
  var close_sales_notification = document.querySelector('.close-sales-notification');
  close_sales_notification.addEventListener('click', function(event) {
    setCookie("sales_notification_cookie","close_notification");
    notification.classList.add('hide');
  });
  
  /* Update the notification message*/
  if(document.querySelector('.sales-number')){
    salesNumber.innerHTML = sales;
  }
 
  if(document.querySelector('.location')){
    location.innerHTML = loc;
  }
  
  /* Show the notification with slide in effect*/
  notification.forEach((content, index) => {
        // Hide all content elements except the current one
        if (index === currentIndex) {
            content.classList.add('show') ; 
        } else {
            content.classList.remove('hide'); 
        }
    });
  
  /* Hide the notification with slide out effect after 5 seconds*/
  setTimeout(function() {
    notification[currentIndex].classList.add('hide');
    notification[currentIndex].classList.remove('show');
  }, 5000);
}

function sticky_add_to_cart_bar_product_detail_page() {
  const content = document.querySelector('.main-product-form');
  const bar = document.querySelector('.sticky-addtocart-bar-form');
  if(!content) return;
  const observer = new IntersectionObserver(entries => {
    const entry = entries[0];
    updateBar(entry);
  }, { threshold: 0 });

  const updateBar = (entry) => {
    if (!entry.isIntersecting && entry.boundingClientRect.bottom <= 0) {
      bar.classList.add('show');
      bar.classList.remove('hide');
      document.body.style.paddingBottom = `${bar.offsetHeight}px`;
    } else {
      bar.classList.remove('show');
      bar.classList.add('hide');
      document.body.style.paddingBottom = '0px';
    }
  };
  
  if (content) {
    observer.observe(content);
  }

  // Fallback for fast scrolling
  window.addEventListener('scroll', () => {
    const rect = content.getBoundingClientRect();
    if (rect.bottom <= 0) {
      bar.classList.add('show');
      bar.classList.remove('hide');
      document.body.style.paddingBottom = `${bar.offsetHeight}px`;
    } else {
      bar.classList.remove('show');
      bar.classList.add('hide');
      document.body.style.paddingBottom = '0px';
    }
  });
  
  window.addEventListener('resize', () => {
    if (content) {
      observer.observe(content);
    }
  });
}





/* start visitor/order count product details page */
  if (typeof(Storage) !== "undefined") {
     const getVisitorCount = () => {
          let itemsVisitorsArray = sessionStorage.getItem('itemsVisitors') ? JSON.parse(sessionStorage.getItem('itemsVisitors')) : [];
           return itemsVisitorsArray;
      };
     const setVisitorCount = (array) => {
       sessionStorage.setItem('itemsVisitors', JSON.stringify(array));
       return true; 
      };

    /*  const updateVisitorCount = (productIdVisitorCount) => {*/
    function updateVisitorCount() {
      if(document.querySelector(".visitorcounts")){
        var productIdVisitorCount = document.querySelector(".visitorcounts").dataset.prdid;
        const itemsVisitorsArray = getVisitorCount();
        const indexInVisitorCount = findRowIndex(itemsVisitorsArray, 0, productIdVisitorCount);
        if (indexInVisitorCount === -1) { 
          const productVisitorArray = [productIdVisitorCount,getRandomInt(1,50),new Date()];
          itemsVisitorsArray.push(productVisitorArray);
        }
        else {
          
          let diff = getMinutesBetweenDates(new Date() - itemsVisitorsArray[indexInVisitorCount][2]);
          if( parseInt(diff) > 5){
             itemsVisitorsArray.splice(indexInWishlist, 1);
             const productVisitorArray = [productIdVisitorCount,getRandomInt(1,50),new Date()];
             itemsVisitorsArray.push(productVisitorArray);
          }
        }
        if(document.querySelector('.visitorcounts_'+productIdVisitorCount)){
          if(setVisitorCount(itemsVisitorsArray)){
             const itemsVisitorsArray = getVisitorCount();
             const indexInVisitorCount = findRowIndex(itemsVisitorsArray, 0, productIdVisitorCount);
            document.querySelector('.visitorcounts_'+productIdVisitorCount).querySelector('.count').innerHTML = itemsVisitorsArray[indexInVisitorCount][1];
          }
        }
      };
    }
  }
  if (typeof(Storage) !== "undefined") 
  {
     const getOrderCount = () => {
          let itemsVisitorsArray = sessionStorage.getItem('itemsOrders') ? JSON.parse(sessionStorage.getItem('itemsOrders')) : [];
           return itemsVisitorsArray;
      };  
     const setOrderCount = (array) => {
       sessionStorage.setItem('itemsOrders', JSON.stringify(array));
       return true; 
      };
    /*  const updateOrderCount = (productIdVisitorCount) => {*/
    function updateOrderCount() {
       if(document.querySelector(".ordercounts")){
        var productIdVisitorCount = document.querySelector(".ordercounts").dataset.prdid;
        const itemsVisitorsArray = getOrderCount();
        const indexInVisitorCount = findRowIndex(itemsVisitorsArray, 0, productIdVisitorCount);
        if (indexInVisitorCount === -1) { 
          const productVisitorArray = [productIdVisitorCount,getRandomInt(1,35),new Date(),getRandomInt(1,24)];
          itemsVisitorsArray.push(productVisitorArray);
        }
        else {
          
          let diff = getMinutesBetweenDates(new Date() - itemsVisitorsArray[indexInVisitorCount][2]);
          if( parseInt(diff) > 5){
             itemsVisitorsArray.splice(indexInWishlist, 1);
             const productVisitorArray = [productIdVisitorCount,getRandomInt(1,35),new Date(),getRandomInt(1,24)];
             itemsVisitorsArray.push(productVisitorArray);
          }
        }
        if(document.querySelector('.ordercounts_'+productIdVisitorCount)){
          if(setOrderCount(itemsVisitorsArray)){
             const itemsVisitorsArray = getOrderCount();
             const indexInVisitorCount = findRowIndex(itemsVisitorsArray, 0, productIdVisitorCount);
            document.querySelector('.ordercounts_'+productIdVisitorCount).querySelector('#orderItems').innerHTML = itemsVisitorsArray[indexInVisitorCount][1];
            document.querySelector('.ordercounts_'+productIdVisitorCount).querySelector('#orderTime').innerHTML = itemsVisitorsArray[indexInVisitorCount][3];
          }
        }
      };  
    }
  }
/* end visitor/order count product details page */

  function initializeProductSwiperSliders() 
  {
      prodslidevar = document.querySelector(".prodslidevar");
      if(prodslidevar){
        var slidesPerView = prodslidevar.getAttribute("data-slidesPerView");
        var direction = prodslidevar.getAttribute("data-direction");
        var loop = JSON.parse(prodslidevar.getAttribute("data-loop"));
        var autoHeight = JSON.parse(prodslidevar.getAttribute("data-autoHeight"));
        var thumbdirection = prodslidevar.getAttribute("data-thumbdirection");
        var proid = prodslidevar.getAttribute("data-proid");
        var enablemagnifier = prodslidevar.getAttribute("data-enablemagnifier");
        var magnifierinline = prodslidevar.getAttribute("data-magnifierinline");
        var inlinePane = JSON.parse(prodslidevar.getAttribute("data-inlinePane"));
        var hoverBoundingBox = JSON.parse(prodslidevar.getAttribute("data-hoverBoundingBox"));
        var gallerylayout = prodslidevar.getAttribute("data-gallerylayout");
        var slidesPerViewSlide = prodslidevar.getAttribute("data-slidesPerViewSlide");
        var directionSlide = prodslidevar.getAttribute("data-directionSlide");
        var diffmedia = prodslidevar.getAttribute("data-diffmedia");
        var effect = prodslidevar.getAttribute("data-effect");

        if(document.querySelector(".product-thumbnail-slider")){
    		var thumbslider = new Swiper(".product-thumbnail-slider", {
                slideToClickedSlide: true,
                spaceBetween: 15,
                loopedSlides: 50,
                watchOverflow: true,
                loop: false,
                a11y: false,
                freeMode: true,
                updateOnImagesReady: true,
                preloadImages: false,
                lazyLoading: true,
                allowTouchMove: true,
                watchSlidesProgress: true,
               // centeredSlides: true,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev"
                },
                breakpoints: {
                   320: {
                      direction: 'horizontal',
                      slidesPerView: 3
                   },
                   480: {
                     direction: 'horizontal',
                     slidesPerView: 4,
                   },
                   768: {
                     direction: 'horizontal',
                     slidesPerView: 5,
                   },
                   992: {
                        direction: directionSlide,
                        slidesPerView: slidesPerViewSlide,
                    },
                  }
              
    		});
        }

        
        if(diffmedia == "" || diffmedia == null){
              var mainproslider = new Swiper(".product-main-slider", {
                  longSwipesRatio:0.2,
                  touchRatio:2,
                  speed: 600,
                  loop: false,
                  a11y: false,
                  spaceBetween: 0,
                  autoHeight: true,
                  watchOverflow: true,
                  allowTouchMove: true,
                  slideToClickedSlide: true,
                  updateOnImagesReady: true,
                  preloadImages: false,
                  lazyLoading: true,
                  loopedSlides: 50,
                  loopPreventsSliding: false,
                  breakpoints: {
                    992: {
                        direction: direction,
                        slidesPerView: slidesPerView,
                        loop: loop,
                        autoHeight: autoHeight,
                    }
                  },			
                  pagination: {
                      el: '.swiper-pagination',
                      clickable: true
                  },
                  navigation: {
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev"
                  },
               

                
              on: { init:
                
                  function () {
                         document.querySelectorAll('.product-form-input input[type="radio"]').forEach((item) => {
                              
                           if(typeof item.dataset.mediaid !== "undefined"){
                           item.addEventListener('click', (event) => {
                                var slideIndex = 0;
                                 var flag_slideIndex = true;
                                this.slides.forEach((slide, index) => {
                                  if(slide.dataset.mediaVariantid == item.dataset.mediaid){
                                    if (flag_slideIndex){
                                      slideIndex = index;
                                      flag_slideIndex = false;
                                    }
                                    
                                  }
                                });
                                   this.slideTo(slideIndex);
                           });
                             }
                          });
                          document.querySelectorAll('.product-form-input select').forEach((item) => {
                              if(typeof item.dataset.mediaid !== "undefined"){
                            item.addEventListener('change', (event) => {
                                var slideIndex = 0;
                             var flag_slideIndex = true;
                                this.slides.forEach((slide, index) => {
                                  if(slide.dataset.mediaVariantid == item.dataset.mediaid){
                                  
                                    if (flag_slideIndex){
                                      slideIndex = index;
                                      flag_slideIndex = false;
                                    }
                                    
                                  }
                                });
                              
                                   this.slideTo(slideIndex);

                            });
                             }
                            
                          });
              
              },
              afterInit: (swiper) => {
                swiper.thumbs.swiper.params.slideToClickedSlide = true;
                swiper.thumbs.swiper.update();
              },
              realIndexChange: (swiper) => {
                swiper.thumbs.swiper.slideToLoop(swiper.realIndex);
              },
              
                   
                  },
                thumbs: {
                  swiper: thumbslider
                },

            });
        }else{

          var swiperConfig = {
            loop: true,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
              enabled: true,
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            keyboard: {
              enabled: true
            },
               

                
              on: { init:
                
                  function () {
                         document.querySelectorAll('.product-form-input input[type="radio"]').forEach((item) => {
                              
                           if(typeof item.dataset.mediaid !== "undefined"){
                           item.addEventListener('click', (event) => {
                                var slideIndex = 0;
                                 var flag_slideIndex = true;
                                this.slides.forEach((slide, index) => {
                                  if(slide.dataset.mediaVariantid == item.dataset.mediaid){
                                    if (flag_slideIndex){
                                      slideIndex = index;
                                      flag_slideIndex = false;
                                    }
                                    
                                  }
                                });
                                   this.slideTo(slideIndex);
                           });
                             }
                          });
                          document.querySelectorAll('.product-form-input select').forEach((item) => {
                              if(typeof item.dataset.mediaid !== "undefined"){
                            item.addEventListener('change', (event) => {
                                var slideIndex = 0;
                             var flag_slideIndex = true;
                                this.slides.forEach((slide, index) => {
                                  if(slide.dataset.mediaVariantid == item.dataset.mediaid){
                                  
                                    if (flag_slideIndex){
                                      slideIndex = index;
                                      flag_slideIndex = false;
                                    }
                                    
                                  }
                                });
                              
                                   this.slideTo(slideIndex);

                            });
                             }
                            
                          });
              
              },
                  },       
            

          };
          
          if (effect === "coverflow") {
            swiperConfig.effect = "coverflow";
            swiperConfig.grabCursor = true;
            swiperConfig.centeredSlides = true;
            swiperConfig.coverflowEffect = {
              rotate: 0,
              stretch: 0,
              depth: 300,
              modifier: 3,
              slideShadows: true
            };
            swiperConfig.breakpoints = {
              640: {
                slidesPerView: 2
              },
              768: {
                slidesPerView: 1
              },
              1024: {
                slidesPerView: 2
              },
              1560: {
                slidesPerView: 3
              }
            };
          } else {
            swiperConfig.direction = "horizontal";
            swiperConfig.slidesPerView = 4;
            swiperConfig.spaceBetween = 20;
            swiperConfig.breakpoints = {
              1: {
                slidesPerView: 1
              },
              640: {
                slidesPerView: 1
              },
              768: {
                slidesPerView: 2
              },
              1024: {
                slidesPerView: 3
              },
              1200: {
                slidesPerView: 4
              },
              1560: {
                slidesPerView: 5
              }
            };
            swiperConfig.a11y = false;
            swiperConfig.freeMode = true;
            swiperConfig.grabCursor = true;
            
            
          }
          var mainproslider = new Swiper(".product-main-slider", swiperConfig);

        }
        if(typeof thumbslider === 'object'){
          thumbslider.on("activeIndexChange", function () {
            mainproslider.slideTo(this.realIndex);
          });
        }

		if(thumbdirection == "left" || thumbdirection == "right"){
               document.querySelector(".swiper_thumbnail_"+proid).style.maxHeight =  document.querySelector(".mainPrdImgformaxheight").querySelector("img").height + "px";
        }
        
      /* Zoom Code */
      if(enablemagnifier)
      { 
		 var paneContainer = document.querySelector('.zoom-mg');
		  mainproslider.slides.forEach((slide, index) => {
			  if (typeof Drift !== 'undefined') {			  
				  new Drift(slide.querySelector('img'), {
					paneContainer: paneContainer,
                    inlinePane: inlinePane,
                    hoverBoundingBox: hoverBoundingBox,                    
					containInline: false,
					zoomFactor: 3,
					onShow: function(){ slide.closest('.product').classList.add('magnifier-zooming');},
					onHide: function(){ slide.closest('.product').classList.remove('magnifier-zooming');}
				  });             
			  }
    			slide.querySelector('img').addEventListener("click", function(event){
                  document.querySelector('.product-zoom-modal').classList.add('active');
                  document.body.classList.add('modal-open');
    			});  
            
                if(slide.querySelector('.product-zoom-icon')){
                      slide.querySelector('.product-zoom-icon').addEventListener("click", function(event){
                        document.querySelector('.product-zoom-modal').classList.add('active');
                        document.body.classList.add('modal-open');
                      });   
                  }
		  });		  
      }

        if(document.querySelector('.modal-content-quickview')){
            mainproslider.slides.forEach((slide, index) => {
                slide.querySelector('img').addEventListener("click", function(event){
                  document.querySelector('.product-zoom-modal').classList.add('active');
                  document.body.classList.add('modal-open');
                });
                if(slide.querySelector('.product-zoom-icon')){
                  slide.querySelector('.product-zoom-icon').addEventListener("click", function(event){
                    document.querySelector('.product-zoom-modal').classList.add('active');
                    document.body.classList.add('modal-open');
                  });   
                }
            });
        }
		
		var layoutclassname = "";
		if(gallerylayout == 'stacked'){
			layoutclassname = ".product-stacked-layout";
		}else if(gallerylayout == 'grid-2-column'){
			layoutclassname = ".product-grid-2-column-layout";
		}else if(gallerylayout == 'grid-gallery'){
			layoutclassname = ".product-grid-gallery-layout";
		}else if(gallerylayout == 'grid-combined'){
			layoutclassname = ".product-grid-combined-layout";
		}else if(gallerylayout == 'thumbnail_slider'){
			layoutclassname = ".product-thumbnail_slider-layout";
		}else if(gallerylayout == 'thumbnail'){	
			layoutclassname = ".product-thumbnail-layout";
		}


        if (gallerylayout == 'stacked' || 
            gallerylayout == 'thumbnail' || 
            gallerylayout == 'grid-2-column' ||
            gallerylayout == 'grid-gallery' ||
            gallerylayout == 'grid-combined'){    
         
                  var paneContainer = document.querySelector('.zoom-mg');
                  
                  var slideLayout =  document.querySelector(layoutclassname);
                  slideLayout.querySelectorAll('.swiper-slide').forEach((slide, index) => { 
                        slide.querySelector('img').addEventListener("click", function(event){
                            document.querySelector('.product-zoom-modal').classList.add('active');    
                            document.body.classList.add('modal-open');
                        });  
                       if(slide.querySelector('.product-zoom-icon')){
                          slide.querySelector('.product-zoom-icon').addEventListener("click", function(event){
                              document.querySelector('.product-zoom-modal').classList.add('active');
                              document.body.classList.add('modal-open');
                          });   
                       }
                  }); 
              }
          /* End of Zoom Code */
          if(document.querySelector('.product-zoom-modal-close')){
                    document.querySelector('.product-zoom-modal-close').addEventListener("click", function(event){
                        document.querySelector('.product-zoom-modal').classList.remove('active');
                        document.body.classList.remove('modal-open');
                    });
                }		  
            }
	  
	  		  /* Product Page Main Product Slider */
			  if (document.querySelector('.mainproslider')) {
					var mainprosliderzoom = new Swiper(".mainproslider", {
					navigation: {
					  nextEl: ".slider-button-next",
					  prevEl: ".slider-button-prev",
					},
                    noSwipingClass: 'swiper-no-swiping',
                    noSwiping: true,
                    allowTouchMove:false,  
                    
				  });

                  /* To set a clicked slide in popup */
                  if(typeof mainproslider === "object"){
                      mainproslider.slides.forEach((slide, index) => {
                          slide.addEventListener('click', (event) => {
                            var slideIndex = 0;
                            var flag_slideIndex = true;
                            mainprosliderzoom.slides.forEach((slidezoom, index) => {
                                if(slide.dataset.mediaVariantid == slidezoom.dataset.mediaid){
                                  if (flag_slideIndex){
                                    slideIndex = index;
                                    flag_slideIndex = false;
                                  }
                                }
                               });
                                mainprosliderzoom.slideTo(slideIndex);
                          });
                      });
                  }
                          
				
				/* Code for zoomin and zoomout mainproduct popup slider image */
				  addImageClickListener();
				  mainprosliderzoom.on('slideChange', function() {
					addImageClickListener(false);
				  });

				function addImageClickListener() {
				  let isZoomedIn = false;
				  var swiperContainer = document.querySelector('.product-zoom-modal .mainproslider');
				  swiperContainer.addEventListener('click', function(event) {
					  
					  if (event.target.tagName === 'IMG') {
						if (isZoomedIn) {
							event.target.classList.remove('imgzoominout');
						} else {
							event.target.classList.add('imgzoominout');                  
						}
						isZoomedIn = !isZoomedIn;
					  }
				  });
			  }
			  /* End Code for zoomin and zoomout mainproduct popup slider image */
			}
			/* end of slider code */

  }/* initializeSwipers Function Closing */

/* Share Button input box copy code */
const copyButtons = document.querySelectorAll('.share-button-copy');
if(copyButtons){
    copyButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            const inputElement = this.closest('.field-group').querySelector('.shareinput');
            inputElement.select();
            inputElement.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(inputElement.value);
            const copiedButton = this.closest('.field-group').querySelector('.share-button-copied');
            copiedButton.classList.remove('hidden');
            this.classList.add('hidden');
        });
    });
}
/* End of Share Button input box copy code */

function qtyincdec(){
  
  const quantityContainers = document.querySelectorAll('.quantity:not(.listening)');
    quantityContainers.forEach(container => {
      container.classList.add("listening");
      const minusButton = container.querySelector('.quantity-button.minus');
      const plusButton = container.querySelector('.quantity-button.plus');
      const quantityInput = container.querySelector('.quantity-input');

      if(minusButton){
        minusButton.addEventListener('click', function () {
          let currentValue = parseInt(quantityInput.value);
          if (currentValue > parseInt(quantityInput.min)) {
            quantityInput.value = currentValue - 1;
          }
        });
      }

      if(plusButton){
        plusButton.addEventListener('click', function () {
          let currentValue = parseInt(quantityInput.value);
          quantityInput.value = currentValue + 1;
        });
      }
    });
}
/* End of Customer Account Show Hide Address Form Code */


/*function subMegaMenu(menutofetch = '[data-menuid]') {
  const menuitems = document.querySelector(menutofetch);
  if (!menuitems) {
    console.log("No menu items found.");
    return;
  }

  const menuContentURL = menuitems.dataset.megamenucontent;

  fetch(menuContentURL)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      document.querySelectorAll(menutofetch).forEach(menuitem => {
        const menuid = menuitem.dataset.menuid;
        if(menuid !== null && menuid != "") {
          if (!menuitem.classList.contains("megamenucontentloaded")) {
            const contentToInject = doc.querySelector(`[data-menuid="${menuid}"]`);
            
            if (contentToInject) {
              menuitem.innerHTML = contentToInject.innerHTML;
              menuitem.classList.add("megamenucontentloaded");
            } else {
              console.error(`Content for menuId "${menuId}" not found in the fetched data.`);
            }
          }
        }
      });
    })
    .catch(error => {
      console.error('Error fetching the page:', error);
    })
    .finally(() => {
      menuscript();
    });
}*/

// Check for sessionStorage availability
function isSessionStorageAvailable() {
  try {
    const test = '__test__';
    sessionStorage.setItem(test, test);
    sessionStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}

// Function to cache and retrieve HTML data using sessionStorage
function cacheHtmlData(requestUrl, htmlData) {
  const cacheDuration = 15 * 60 * 1000; // 15 minutes in milliseconds
  const now = Date.now();
  
  if (isSessionStorageAvailable()) {
    // Store the HTML and timestamp in sessionStorage
    const cacheObject = {
      html: htmlData,
      timestamp: now
    };
    sessionStorage.setItem(requestUrl, JSON.stringify(cacheObject));
  }
}

// Function to check if cached data exists and is valid (within cache period)
function getCachedHtmlData(requestUrl) {
  if (isSessionStorageAvailable()) {
    const cacheObject = sessionStorage.getItem(requestUrl);
    
    if (cacheObject) {
      const parsedCache = JSON.parse(cacheObject);
      const now = Date.now();
      
      // Check if cache is still valid (within the 15-minute duration)
      if (now - parsedCache.timestamp < 15 * 60 * 1000) {
        return parsedCache.html; // Return cached HTML data
      } else {
        sessionStorage.removeItem(requestUrl); // Remove stale cache
      }
    }
  }
  return null; // No valid cache found
}

function subMegaMenu(menutofetch = '[data-menuid]') {
  const menuitems = document.querySelector(menutofetch);
  if (!menuitems) {
    console.log("No menu items found.");
    return;
  }

  const menuContentURL = menuitems.dataset.megamenucontent;

  // Check if the menu content is cached
  const cachedData = getCachedHtmlData(menuContentURL);
  if (cachedData) {
    injectMenuContent(cachedData, menutofetch);
    //console.log("Loaded from cache");
    menuscript();
  } else {
    // Fetch the content if not cached
    fetch(menuContentURL)
      .then(response => response.text())
      .then(html => {
        cacheHtmlData(menuContentURL, html); // Cache the fetched HTML
        injectMenuContent(html, menutofetch);
      })
      .catch(error => {
        console.error('Error fetching the page:', error);
      })
      .finally(() => {
        menuscript();
      });
  }
}

// Function to inject the menu content
function injectMenuContent(html, menutofetch) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  
  document.querySelectorAll(menutofetch).forEach(menuitem => {
    const menuid = menuitem.dataset.menuid;
    if (menuid !== null && menuid !== "") {
      if (!menuitem.classList.contains("megamenucontentloaded")) {
        const contentToInject = doc.querySelector(`[data-menuid="${menuid}"]`);
        
        if (contentToInject) {
          menuitem.innerHTML = contentToInject.innerHTML;
          menuitem.classList.add("megamenucontentloaded");
        } else {
          console.error(`Content for menuId "${menuid}" not found in the fetched data.`);
        }
      }
    }
  });
}



function checkIfClassExists(className) {
    var elements = document.querySelectorAll(className);
    return elements.length > 0;
}


function cartdrawercontent()
{
     if(checkIfClassExists(".cart-drawer"))
     {
       var cartdrawer = document.querySelector(".cart-drawer");
       cartdrawer.classList.add("loading");
        cartdrawercontentURL = `${window.Shopify.routes.root}?section_id=cart-drawer`; 
         fetch(cartdrawercontentURL)
          .then(response => response.text()) 
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
      
            const contentToInject = doc.querySelector('#cdcontent');
            if (contentToInject) {
              const targetElement = document.querySelectorAll('.cdtarget');
              if (targetElement) {
                  targetElement.forEach(qs => {
                   qs.innerHTML = contentToInject.innerHTML; 
                  });
                 cartdrawer.classList.remove("loading");

                  cartdrawernotes();
                  cartdrawerdiscount();
                  cartdeliverydate();
                  if(typeof Swiper === "undefined") {
                   loadScriptsDelay(window.swiperscript, function () {
                     initializeGlobalSwiperSliders();  
                   });
                  }else{
                    initializeGlobalSwiperSliders();
                  }
                  giftwrapinit();
                  removeGiftWrapCartDrawer();
                
               } else {
                console.error(`Target element targetElement not found on the page.`);
              }
            } else {
              console.error(`Element with data attribute targetElement not found in the fetched page.`);
            }
          })
          .catch(error => {
            console.error('Error fetching the page:', error);
          });
     }
}

function cartdrawerdiscount()
{
  const storedDiscountCode = localStorage.getItem('discount_code');
    if (storedDiscountCode) {
        if(document.getElementById('discount-code')){
          document.getElementById('discount-code').value = storedDiscountCode;          
        }
    }
  var drawerdiscount = document.getElementById('drawerdiscount');
  if(drawerdiscount){
    document.getElementById('drawerdiscount').addEventListener('click', function(event) {
      drawerdiscount.classList.add('loading');
      event.preventDefault();

      setTimeout(() => {
          const discountCode = document.getElementById('discount-code').value;
          localStorage.setItem('discount_code', discountCode);
          drawerdiscount.classList.remove('loading');
          drawerdiscount.classList.add('added');
          setTimeout(() => {
            drawerdiscount.classList.remove('added');
          }, 1000);
     }, 1000);   
    });
  }
}

function cartdrawernotes(){
    if(document.querySelector('#cartdrawernote .cart-note-buttons .button[aria-label="Save"]')){
	  document.querySelector('#cartdrawernote .cart-note-buttons .button[aria-label="Save"]').addEventListener('click', function () {
		var note = document.getElementById('CartDrawer-Note').value;
		var saveButton = this;
		saveButton.classList.add('loading');
	
		fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			},
			body: JSON.stringify({
				note: note
			})
		})
		.then(response => response.json())
		.then(data => {
			setTimeout(() => {
            saveButton.classList.remove('loading');
			saveButton.classList.add('added');
    			setTimeout(() => {
    			  saveButton.classList.remove('added');
    			}, 1000);
            }, 1000);  
		})
		.catch(error => {
			console.error('Error saving note:', error);
		});
	});
  } 
}

function cartdeliverydate(){
    const today = new Date();
    const dateInput = document.getElementById('cartdeliverydate');
    if(dateInput){
		var deliveryConfigElement = document.querySelector('.deliverydateconfig');
        var noOfDaysAfter = deliveryConfigElement.getAttribute('data-noofdays');
        var noOfDaysTo = deliveryConfigElement.getAttribute('data-nodaysto');
      	if(noOfDaysAfter == "0"){
          noOfDaysAfter = 1;
        }
        const noDaysLater = new Date(today);
        noDaysLater.setDate(today.getDate() + noOfDaysAfter );
        const noDaysLaterISO = noDaysLater.toISOString().split('T')[0];
        dateInput.setAttribute('min', noDaysLaterISO);
		
		if(noOfDaysTo != "0"){
		  var toDaysLater = new Date(today);
		  toDaysLater.setDate(today.getDate() + noOfDaysTo );
		  var toDaysLaterISO = toDaysLater.toISOString().split('T')[0];
		  dateInput.setAttribute('max', toDaysLaterISO);
		}
		dateInput.addEventListener('change', function() {
			const selectedDate = this.value;
		});
		document.getElementById('cartdeliverydate').addEventListener('click', function() {
		  this.showPicker();
		});
	  
		document.getElementById('savdeliverydate').addEventListener('click', function() {
		  const deliveryDate = document.getElementById('cartdeliverydate').value;
		  if (!deliveryDate) {
			 var commonconfigval = document.getElementById("commmonconfigval");
			 var deldatelbl = commonconfigval.dataset.deldatelbl;
			document.getElementById("dateError").innerHTML = deldatelbl;
			return;
		  }
		  document.getElementById("dateError").innerHTML = "";
		  var deldatebutton = document.getElementById("savdeliverydate");
			if(deldatebutton){
			  deldatebutton.classList.add('loading');
			}
	  
		  const data = {
			attributes: {
			  'deliverydate': deliveryDate
			}
		  };
	  
		 fetch('/cart/update.js', {
			method: 'POST',
			headers: {
			  'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		  })
		  .then(response => response.json())
		  .then(data => {
			var deldatebutton = document.getElementById("savdeliverydate");
			if(deldatebutton){
			  setTimeout(() => {
              deldatebutton.classList.remove('loading');
			  deldatebutton.classList.add('added');
    			  setTimeout(() => {
    				  deldatebutton.classList.remove('added');
    			  }, 1000);
              }, 1000);  
			}
		  })
		  .catch(error => {
			console.error('Error:', error);
		  });
		});
	}
  }

function giftwrapinit(){
  document.addEventListener('click', function(event) {
    if (event.target.closest('#gift-wrapping')) {
        event.preventDefault();
        setGiftWrap();
    }
  });
}
function saveGiftNote(note){
  var headers = new Headers({ 'Content-Type': 'application/json' });
  var request = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({ attributes: { 'gift-note': note } })
  };
  fetch('/cart/update.js', request);
}
function setGiftWrap() 
{
	var itemsincart = "";
	if(document.getElementById("itemsincart")){
    	itemsincart = document.getElementById("itemsincart").dataset.value;
	}
	var cartDrawer = document.getElementById('rmgwcartdrawer');
	if(cartDrawer){
	  var gwPriceConfig = cartDrawer.dataset.gwpriceconfig;
	  var currtpage = cartDrawer.dataset.template;
      var giftwrapsid = cartDrawer.dataset.gwpid;
	}
    var giftnoteElement = document.getElementById('gift-note');
    if(giftnoteElement){
      var giftnote = giftnoteElement.value;
    }
  
	var headers = new Headers({ 'Content-Type': 'application/json' });
	if(gwPriceConfig == "1"){
	  var request = {
		method: 'POST',
		headers: headers,
		body: JSON.stringify({ updates: { [giftwrapsid] : 1 }, attributes: { 'gift-wrapping': true, 'gift-note': giftnote } })
	  };
	}else{
		var request = {
		  method: 'POST',
		  headers: headers,
		  body: JSON.stringify({ updates: { [giftwrapsid] : itemsincart }, attributes: { 'gift-wrapping': true, 'gift-note': giftnote } })
		};
	}
	if(currtpage != "cart"){
      var giftbutton = document.getElementById("gift-wrapping");
              giftbutton.classList.add('loading');
		fetch('/cart/update.js', request) 
		.then(function() {
			  updateCartDrawer();
			  
			  if(giftbutton){
                
				    giftbutton.classList.remove('loading');
    				giftbutton.classList.add('added');
    				setTimeout(() => {
    					giftbutton.classList.remove('added');
    				}, 500);
                
			  }
			  
		});
	}		
		if(currtpage == "cart"){ 
		fetch('/cart/update.js', request) 
		.then(() => {
		  return fetch('/cart?view=ajax', {
			method: 'GET'
		  });
		})
		.then(response => response.text())
		.then(data => { 
		  
		  const parser = new DOMParser();
		  const doc = parser.parseFromString(data, 'text/html');
		  const cartitemlinenew = doc.querySelector('table.cart-items');
		  const cartitemlineold = document.querySelector('table.cart-items');
		  if (cartitemlineold && cartitemlinenew) {
			cartitemlineold.innerHTML = cartitemlinenew.innerHTML;
		  }
		  const cartSubTotalNew = doc.querySelector('.cart-subtotal');
		  const cartSubTotalOld = document.querySelector('.cart-subtotal');
		  if (cartSubTotalOld && cartSubTotalNew) {
			cartSubTotalOld.innerHTML = cartSubTotalNew.innerHTML;
		  }
		  const cartTotalNew = doc.querySelector('.cart-total');
		  const cartTotalOld = document.querySelector('.cart-total');
		  if (cartTotalOld && cartTotalNew) {
			cartTotalOld.innerHTML = cartTotalNew.innerHTML;
		  }

		  var giftbutton = document.getElementById("gift-wrapping");
		  if(giftbutton){
			giftbutton.classList.remove('loading');
			giftbutton.classList.add('added');
			setTimeout(() => {
				giftbutton.classList.remove('added');
			}, 500);
		  }
		  
		})
		.catch(error => {
		  console.error('Error:', error);
		});
	}
}

function removeGiftWrap()
{
	var cartDrawer = document.getElementById('rmgwcartdrawer');
	if(cartDrawer){
	  var gwPriceConfig = cartDrawer.dataset.gwpriceconfig;
	  var currtpage = cartDrawer.dataset.template;
      var giftwrapsid = cartDrawer.dataset.gwpid;
	}
	
	var headers = new Headers({ 'Content-Type': 'application/json' });
	var request = {
	  method: 'POST',
	  headers: headers,
	  body: JSON.stringify({ updates: { [giftwrapsid]: 0 }, attributes: { 'gift-wrapping': '', 'gift-note': '' } })
	};
	
	if(currtpage != "cart"){
		fetch('/cart/update.js', request)
		.then(function() {
		  updateCartDrawer();
		});
	}

	if(currtpage == "cart"){
		fetch('/cart/update.js', request)	
		.then(() => {
		  return fetch('/cart?view=ajax', {
			method: 'GET'
		  });
		})
		.then(response => response.text())
		.then(data => {          
		  const parser = new DOMParser();
		  const doc = parser.parseFromString(data, 'text/html');
		  const cartitemlinenew = doc.querySelector('table.cart-items');
		  const cartitemlineold = document.querySelector('table.cart-items');
		  if (cartitemlineold && cartitemlinenew) {
			cartitemlineold.innerHTML = cartitemlinenew.innerHTML;
		  }
		  const cartSubTotalNew = doc.querySelector('.cart-subtotal');
		  const cartSubTotalOld = document.querySelector('.cart-subtotal');
		  if (cartSubTotalOld && cartSubTotalNew) {
			cartSubTotalOld.innerHTML = cartSubTotalNew.innerHTML;
		  }
		  const cartTotalNew = doc.querySelector('.cart-total');
		  const cartTotalOld = document.querySelector('.cart-total');
		  if (cartTotalOld && cartTotalNew) {
			cartTotalOld.innerHTML = cartTotalNew.innerHTML;
		  }          
		})
		.catch(error => {
		  console.error('Error:', error);
		});
	}	
  }

function removeGiftWrapCartDrawer()
{
	const cartDrawer = document.getElementById('rmgwcartdrawer');
	if(cartDrawer){
		const cart_size = cartDrawer.dataset.cartsize;
		const items_in_cart = cartDrawer.dataset.itemincart;
		const gift_wraps_in_cart = cartDrawer.dataset.giftwrapincart;
		const gwPriceConfig = cartDrawer.dataset.gwpriceconfig;
 
		if(gwPriceConfig == "1"){
			if (cart_size == 1 && gift_wraps_in_cart > 0){
				removeGiftWrap();
				emptygiftwrap();
			}
			else if (gift_wraps_in_cart > 1){
                setGiftWrap();
			}
		}else{
			if (cart_size == 1 && gift_wraps_in_cart > 0){
                removeGiftWrap();
				emptygiftwrap();
			}
			else if (gift_wraps_in_cart > 0 && gift_wraps_in_cart != items_in_cart){
                setGiftWrap();
			}
		}
	}
}

function emptygiftwrap()
{        
  const cartDrawer = document.getElementById('rmgwcartdrawer');
  if(cartDrawer){
      var currtpage = cartDrawer.dataset.template;
      if(currtpage != 'cart'){
        document.querySelectorAll('.emptydrawer').forEach(function(element) {
          element.classList.remove('cart-drawer-empty');
          element.classList.add('cart-drawer-show');
          document.querySelectorAll('.cart-popup').forEach(function(element) {
            element.classList.add('cart-is-empty');
          });
        });
        document.querySelectorAll('.showdrawer').forEach(function(element) {
          element.classList.add('cart-drawer-empty');
          element.classList.remove('cart-drawer-show');
        });
      }
      if(currtpage == 'cart'){    
          fetch('/cart/clear.js', {
              method: 'POST',
              headers: {
              'Content-Type': 'application/json'
              }
          })
          .then(response => response.json())
          .then(data => {
              window.location.reload();
          })
          .catch((error) => {
              console.error('Error:', error);
          });
      }
  }
}


function headerStickyType()
{
	var stickyheadtype = document.getElementById('site-header');
	if(stickyheadtype){
		var headerConfigVal = stickyheadtype.dataset.stickyheadtype;
		var headerElement = document.querySelector('.header-section');
        const headerOffset = headerElement.offsetTop;

      	if (headerConfigVal == "on-scroll-up") {
		  let lastScrollTop = 0;
         // let lastScrollTop = headerOffset;
		  window.addEventListener("scroll", function () {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > headerOffset) {
            headerElement.classList.add('header-sticky');
              
    			if (scrollTop > lastScrollTop) {
    
    			  headerElement.classList.add("header-sticky-hidden");
    			  headerElement.classList.remove("header-sticky");
    			} else {
    			 /* if (scrollTop == 0) {
    				headerElement.classList.remove("header-sticky");
    				headerElement.classList.remove("header-sticky-hidden");
    			  } else {*/
    				headerElement.classList.add("header-sticky");
    				headerElement.classList.remove("header-sticky-hidden");
    			  /*}*/
    			}
            }else{
              headerElement.classList.remove("header-sticky");
    		  headerElement.classList.remove("header-sticky-hidden");
            }
              
			lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
		  }, false);
		}

		if (headerConfigVal == "always") {
		  /* Function to call when the element is not visible */
		  function handleNotVisible(entries, observer) {
			entries.forEach(entry => {
			  if (!entry.isIntersecting) {
				headerElement.classList.add("header-always");
			  }
			});
		  }
		  window.addEventListener("scroll", function () {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			if (scrollTop == 0) {
			  headerElement.classList.remove("header-always");
			}
		  }, false);

		  /* Create an Intersection Observer instance */
		  let observer = new IntersectionObserver(handleNotVisible, {
			root: null,
			threshold: 0.8
		  });

		  /* Target element to observe */
		  let targetElement = document.querySelector('.header-section');

		  /* Start observing the target element */
		  observer.observe(targetElement);
		}
	}
}

/* ================================== Menu Code Start From Here ================================== */
function menuscript(){
      const parentLists = document.querySelectorAll('.main-nav');
      parentLists.forEach(parentList => {
      const svgElements = parentList.querySelectorAll('.mbmenucontent svg'); 
      svgElements.forEach(svgElement => {
      svgElement.addEventListener('click', () => {
      event.stopPropagation();
      const parentLi = event.target.closest("li");
      	if (parentLi.classList.contains('dd-parent')){
      		const elements = document.querySelectorAll('.dd-parent');
      		elements.forEach(element => {
            element.classList.remove('onclicked');
        });
  	}
    if(parentLi.classList.contains("backto")){
    	event.target.closest('.onclicked').classList.remove('onclicked');
    	return;
    }
        if (parentLi.classList.contains('has-dropdown') || parentLi.classList.contains('has-megamenu') || parentLi.classList.contains('dd-child')) {
            event.preventDefault();
            if(parentLi.classList.contains('dd-child') && screen.width > 1199){
                const ddchild = document.querySelectorAll('.dd-child');
                ddchild.forEach(item => {
                    item.classList.remove('onclicked');
                });
            }else{

            }
            parentLi.classList.toggle('onclicked');
        }
      });
     });
   });

  if (document.querySelector('.inline-navigation') || document.querySelector('.condensed-navigation')) {
   if(screen.width > 1199){
  const parentToggle = document.querySelectorAll(".dd-parent svg");

  parentToggle.forEach(function (pToggle) {
  	pToggle.addEventListener("click", (event) => {
  		const parentLi = event.target.closest("li");
  		if (parentLi.classList.contains('mbtoggle')) {
  	parentLi.classList.remove('mbtoggle');
  			parentLi.classList.remove('onclicked');
  		} else {
  	var parentElements = document.querySelectorAll('.dd-parent');
  	parentElements.forEach(pe => {
  		pe.classList.remove('mbtoggle');
  	});
  	var childElements = document.querySelectorAll('.dd-child');
  	childElements.forEach(ce => {
  		ce.classList.remove('mbtoggle');
  	});
  			parentLi.classList.add('mbtoggle');
  		}
  	});
  });
   }
  }

  const menuTabs = document.querySelectorAll('.menutab');
  menuTabs.forEach(tab => {
    tab.addEventListener('click', function(event) {
      event.preventDefault();
   if(this.classList.contains('menu-tab')){
      document.getElementById("header-list-menu").classList.add('active');  
     document.getElementById("header-list-categories").classList.remove('active');
     document.getElementById("header-list-account").classList.remove('active');     
   }
   if(this.classList.contains('categories-tab')){
     document.getElementById("header-list-menu").classList.remove('active'); 
     document.getElementById("header-list-categories").classList.add('active');
     document.getElementById("header-list-account").classList.remove('active');
   }
    if(this.classList.contains('account-tab')){
     document.getElementById("header-list-menu").classList.remove('active'); 
     document.getElementById("header-list-categories").classList.remove('active');
      document.getElementById("header-list-account").classList.add('active');
   }      
      menuTabs.forEach(t => {
        t.classList.remove('active');
      });
      this.classList.add('active');
    });
  });
}

function menuOpenClose(){
   /* For Open the Menu */
   	const toggleElement = document.getElementById("mainNav-toggle");
  if(toggleElement != null){
   	toggleElement.addEventListener("click", (event) => {
        if (document.querySelector('.condensed-navigation')) {
  	if(screen.width < 1199){
  		document.body.classList.toggle("menu-open");
  	}
    }else{
    	document.body.classList.toggle("menu-open");
    }
      toggleElement.classList.toggle("onclicked");
      const menuclass = document.querySelector('.main-nav');
      menuclass.classList.toggle('displayed');
   	});
}
  document.addEventListener('click', closeMe);
  function closeMe(event) {
    if (!toggleElement.contains(event.target)) {
  if (document.querySelector('.condensed-navigation')) {
  	if(screen.width > 1199){
  		mainNav = document.getElementById("mainNav-toggle");
  		mainNav.classList.remove('onclicked');
  		menuclass = document.querySelector('.main-nav');
  		menuclass.classList.remove('displayed');
  	}
  }
  if (document.querySelector('.inline-navigation')) {
  	const elements = document.querySelectorAll('.dd-parent');
  	elements.forEach(element => {
  		element.classList.remove('onclicked');
  	});
  }
  }
  }
   	const closeBtn = document.getElementById("menu-drawer-close");
  if(closeBtn != null){
   	closeBtn.addEventListener("click", () => {
  if (document.querySelector('.condensed-navigation')) {
  	if(screen.width < 1199){
  		document.body.classList.toggle("menu-open");
  	}
  }else{
  	document.body.classList.toggle("menu-open");
  }
      const mainNav = document.getElementById("mainNav-toggle");
      mainNav.classList.remove('onclicked');

      const menuclass = document.querySelector('.main-nav');
      menuclass.classList.remove('displayed');
   	});
  }

   	/* Back Button Code */
   	const backClass = document.querySelectorAll(".backto");
   	backClass.forEach(function (backClass) {
   		backClass.addEventListener("click", (event) => {
   			event.target.closest('.onclicked').classList.remove('onclicked');
   		});
   	});
}


/* ================================== End of Menu Code ================================== */


/* ================================== Start Shopify Money Code ================================== */
var Shopify = Shopify || {};
Shopify.money_format = "{{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;  
  }
  return formatString.replace(placeholderRegex, value);
};
/* ================================== End of Shopify Money Code ================================== */

/* ================================== Start of Model 3d Viewer Code ================================== */
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}
function pauseAllMedia() {  
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}



if (!customElements.get('product-model')) {
  customElements.define('product-model', class ProductModel extends DeferredMedia {
    constructor() {
      super();
    }
    loadContent() {
      super.loadContent();
      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }
    setupModelViewerUI(errors) {
      if (errors) return;
      this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
    }
  });
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;
    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () =>
        this.setupShopifyXR()
      );
      return;
    }
    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

/* ================================== End of Model 3d Viewer Code ================================== */


/* ================================== Start Multi-Addtocart Code ================================== */

function multibundle()
{
	  var commonconfigval = document.getElementById("commmonconfigval");
	  var onlyadd = commonconfigval.dataset.onlyadd;
	  var itemfor = commonconfigval.dataset.itemfor;
	  var qtyunfortunately = commonconfigval.dataset.qtyunfortunately;
	  var outofstock = commonconfigval.dataset.outofstock;
	
      var product_listproductqty_button = document.querySelectorAll(".list-product-qty:not(.listening)");
      if(product_listproductqty_button){
        product_listproductqty_button.forEach(el => { el.classList.add('listening'); el.addEventListener('keyup', event => {
          event.stopImmediatePropagation();
          var ele_id = event.target.parentElement.querySelector('.list-product-qty');
          var qtyInput = ele_id;
          var currentVal = parseInt(qtyInput.value) || 0;
          var qtyMax = parseInt(qtyInput.getAttribute('max'));
          var title = ele_id.dataset.producttitle;
    
          if (currentVal > qtyMax) {
			alert(onlyadd+" "+qtyMax+" "+itemfor+" "+title);
            qtyInput.value = qtyMax;
          }
          
        })
                                                    });
      }
      var product_qtyplus_button = document.querySelectorAll(".qtyplus:not(.listening)");
   	  if(product_qtyplus_button){
        product_qtyplus_button.forEach(el => { el.classList.add('listening'); el.addEventListener('click', event => {
           event.stopImmediatePropagation();
              var ele_id = event.target.parentElement.querySelector('.list-product-qty');
              var qtyInput = ele_id;            
              var currentVal = parseInt(qtyInput.value) || 0;
              var qtyMax = parseInt(qtyInput.getAttribute('max'));
              var title = ele_id.dataset.producttitle;
              if(qtyMax  == 0){
                alert(qtyunfortunately+" "+title +" "+outofstock);
              }  
              else if (currentVal >= qtyMax) {
				alert(onlyadd+' '+qtyMax+' '+itemfor+' '+title);
                qtyInput.value = qtyMax;
              } else {
                qtyInput.value = parseInt(currentVal + 1);
              }
          updatebundleproductsprice(event.target.closest('.product-multiaddtocart'));
        })  });
      }
      var product_qtyminus_button = document.querySelectorAll(".qtyminus:not(.listening)");
   	  if(product_qtyminus_button){
          product_qtyminus_button.forEach(el => { el.classList.add('listening'); el.addEventListener('click', event => {
            event.stopImmediatePropagation();
                 var ele_id = event.target.parentElement.querySelector('.list-product-qty');
                  var qtyInput = ele_id;
                  var currentVal = parseInt(qtyInput.value);            
                  if (currentVal == 1) {
                    qtyInput.value = currentVal;
                  }else {
                    if (currentVal >= 1) {
                    qtyInput.value = currentVal - 1;
                    }
                  }
            updatebundleproductsprice(event.target.closest('.product-multiaddtocart'));
        }) });
      }
      var product_showhidevariant_button = document.querySelectorAll(".showhidevariant:not(.listening)");
   	  if(product_showhidevariant_button){
        product_showhidevariant_button.forEach(el => { el.classList.add('listening'); el.addEventListener('click', event => {
          event.stopImmediatePropagation();
          var variantof_productid = event.target.dataset.variantproid;
          document.querySelectorAll('.' + variantof_productid).forEach(function (element) {
            element.style.display = element.style.display === 'none' ? 'table-row' : 'none';
          });
          event.target.value = event.target.value === 'Show Options' ? 'Hide Options' : 'Show Options';
        }) });
      } 
let formData = {
  'items': []
};
  
function multiAddtoCart()
{
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    formData.items = [];
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(() => {
        updateCartDrawer();
    });
}  
  document.querySelectorAll('.current_list-add-to-cart').forEach((item) => {
        item.addEventListener('click', function (event) {
          event.stopImmediatePropagation();
          item.classList.add('loading');
          var multiaddtocart = this;
          multiaddtocart.querySelector('.loading-overlay-spinner').classList.remove('hidden');
          var i = 0;
          var last_element = "";
          var last_element_qty = 0;       
          var parentContainer_productlist = multiaddtocart.closest('.product-multiaddtocart');
          parentContainer_productlist.querySelectorAll('.list-product-qty').forEach(function (element) {
            var flagfbtchecked = true;
            if(element.closest('.prdrow').querySelector('.fbtchekbox')){
              if(!element.closest('.prdrow').querySelector('.fbtchekbox').checked){
                flagfbtchecked = false;
              }
            }
            if(element.value != '' && element.value > 0 && flagfbtchecked)
			{
              formData.items.push({ 'id': element.dataset.productid, 'quantity': element.value });
              last_element = element;
              last_element_qty = element.value;
              element.value = multiaddtocart.dataset.resetqty;
            }
           });
    if(formData.items.length == 0){
	  var commonconfigval = document.getElementById("commmonconfigval");
	  var qtyinputlbl = commonconfigval.dataset.qtyinputlbl;
      alert(qtyinputlbl);
      this.querySelector('.loading-overlay-spinner').classList.add('hidden');
      document.querySelector('.current_list-add-to-cart').classList.remove('loading');
      
    }else{
      if(formData.items.length > 0){
        
        multiAddtoCart();
      }
      setTimeout(function() {
          last_element.value =  last_element_qty; 
          last_element.value = multiaddtocart.dataset.resetqty;
          multiaddtocart.querySelector('.loading-overlay-spinner').classList.add('hidden');
          updatebundleproductsprice(event.target.closest('.product-multiaddtocart'));
          item.classList.remove("loading");
          item.classList.add('added');
                setTimeout(() => {
                    item.classList.remove('added');
                }, 500);
        }, 1000);  
    }
  });
 }); 

  const formatter = new Intl.NumberFormat(Shopify.locale, {
   minimumFractionDigits: 2,      
   maximumFractionDigits: 2,
  });

  let selectvariantsbundle = document.querySelectorAll(".select-select_bundle");
  selectvariantsbundle.forEach(el => el.addEventListener('change', event => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if(event.target.closest('.prdrow').querySelector('input[name=bid]')){
      event.target.closest('.prdrow').querySelector('input[name=bid]').value = event.target.value;
    }
    updatebundleproductsprice(event.target.closest('.product-multiaddtocart'));
  })); 

  let qtyvariantsbundle = document.querySelectorAll(".list-product-qty");
  qtyvariantsbundle.forEach(el => el.addEventListener('input', event => {            
    event.preventDefault();
    event.stopImmediatePropagation();
    updatebundleproductsprice(event.target.closest('.product-multiaddtocart'));
  })); 

  let fbtchkboxbundle = document.querySelectorAll(".fbtchekbox");
  fbtchkboxbundle.forEach(el => el.addEventListener('click', event => {
    let checkedBoxes = document.querySelectorAll(".fbtchekbox:checked");
    if (checkedBoxes.length >= 1) {
        updatebundleproductsprice(event.target.closest('.product-multiaddtocart'));
    }
  })); 

  function updatebundleproductsprice(objprdlistbundle){
    var objprice = 0;
    objprdlistbundle.querySelectorAll(".select-select_bundle").forEach(function (element) {
      if(element.closest('.prdrow').querySelector('.fbtchekbox')){
          if(parseFloat(element.closest('.prdrow').querySelector('.list-product-qty').value) > 0 && element.closest('.prdrow').querySelector('.fbtchekbox').checked){
             objprice = objprice + parseFloat(element.options[element.selectedIndex].dataset.price) * parseFloat(element.closest('.prdrow').querySelector('.list-product-qty').value);
             element.closest('.prdrow').querySelector('.list-product-qty').dataset.productid = element.options[element.selectedIndex].value; 
          }
      }else{
        if(parseFloat(element.closest('.prdrow').querySelector('.list-product-qty').value) > 0){
           objprice = objprice + parseFloat(element.options[element.selectedIndex].dataset.price) * parseFloat(element.closest('.prdrow').querySelector('.list-product-qty').value);
          element.closest('.prdrow').querySelector('.list-product-qty').dataset.productid = element.options[element.selectedIndex].value;
        }
      }
    });
    if(objprdlistbundle.querySelector('.totalprice')){
      objprdlistbundle.querySelector('.totalprice').innerHTML = objprice.toFixed(2);
    }    
  }
  let selectbundlecontainer = document.querySelectorAll(".product-multiaddtocart");
  selectbundlecontainer.forEach(function (element) {
     var objprice = 0;  
    element.querySelectorAll(".select-select_bundle").forEach(function (element) {
      if(parseFloat(element.closest('.prdrow').querySelector('.list-product-qty').value) > 0){
         objprice = objprice + parseFloat(element.options[element.selectedIndex].dataset.price) * parseFloat(element.closest('.prdrow').querySelector('.list-product-qty').value);
        element.closest('.prdrow').querySelector('.list-product-qty').dataset.productid = element.options[element.selectedIndex].value;
      }
      });
     if(element.querySelector('.totalprice')){
      element.querySelector('.totalprice').innerHTML = objprice.toFixed(2);
    }
  });
}
/* ================================== End of Multi-Addtocart Code ================================== */


/* ================================== Start Swiper Global Script ================================== */

function initializeGlobalSwiperSliders() {
  var mbsliders = document.querySelectorAll(".mbswiperslider:not(.swiper-initialized)");
  mbsliders.forEach(function (mbslider){
    globalslider(mbslider);
  });
}

  function globalslider(mbslider){
      var mbslidersectionid = mbslider.getAttribute("data-mbslidersectionid");
      if (!mbslidersectionid) {
        return;
      }
      var mbautostart = JSON.parse(mbslider.getAttribute("data-autostart")) || 0;
      var pauseonmouse = JSON.parse(mbslider.getAttribute("data-pauseonmouse")) || 1;
      var sliderduration = mbslider.getAttribute("data-sliderduration");
      var loopslider = JSON.parse(mbslider.getAttribute("data-loopslider")) || 0;
      var animationtype = mbslider.getAttribute("data-animationtype");
      var scrollbareffect = mbslider.getAttribute("data-scrollbareffect");
      var showarrow = mbslider.getAttribute("data-showarrow");
      var showpagination = mbslider.getAttribute("data-showpagination");
      var showtextbelow = mbslider.getAttribute("data-showtextbelow");
      var layout = mbslider.getAttribute("data-layout");
      var rewind = JSON.parse(mbslider.getAttribute("data-rewind")) || 0;
      var slidesauto = JSON.parse(mbslider.getAttribute("data-slidesauto")) || "auto";
      var gridcolumn_mobile = mbslider.getAttribute("data-gridcolumn_mobile");
      var gridcolumn_ipads = mbslider.getAttribute("data-gridcolumn_ipads");
      var gridcolumn_tablet = mbslider.getAttribute("data-gridcolumn_tablet");
      var gridcolumn_desktop = mbslider.getAttribute("data-gridcolumn_desktop");
      var centeredSlides = JSON.parse(mbslider.getAttribute("data-centeredSlides"));
      var numofrows = JSON.parse(mbslider.getAttribute("data-numofrows")) || 1; 
       
      var mySwiper = "mySwiper_"+mbslidersectionid;
      mySwiper = new Swiper("#mbslider-" + mbslidersectionid, {
        autoplay: mbautostart ? {
            delay: sliderduration + "000",
            disableOnInteraction: false,
            pauseOnMouseEnter: pauseonmouse,
        } : false,        
        loop: loopslider,
        a11y: false,
        slidesPerView: "auto",
        rewind: rewind,
        effect: animationtype,
        watchOverflow: true,
        allowTouchMove: true,
        centeredSlides: centeredSlides,
        centeredSlidesBounds: centeredSlides,
        cubeEffect: {
          shadow: true,
          slideShadows: true,
          shadowOffset: 20,
          shadowScale: 0.94
        },
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 300,
          modifier: 3,
          slideShadows: true
        },
        creativeEffect: {
          prev: {
            shadow: true,
            translate: [0, 0, -800],
            rotate: [180, 0, 0]
          },
          next: {
            shadow: true,
            translate: [0, 0, -800],
            rotate: [-180, 0, 0]
          }
        },
        scrollbar: {
          el: ".mbscrollbar-" + mbslidersectionid,
          hide: false,
          draggable: true,
          dragSize: 200
        },
        keyboard: { enabled: true },
        grabCursor: true,
        navigation: {
          nextEl: ".mbnextbtn-" + mbslidersectionid,
          prevEl: ".mbprevbtn-" + mbslidersectionid
        },
        pagination: {
          el: ".mbpagination-" + mbslidersectionid,
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="swbullet ' + className + '">' + (index + 1) + "</span>";
          }
        },
        on: {
            init: function () {
              document.querySelector("#mbslider-"+mbslidersectionid).classList.add("slide-rotating");
              toggleSliderArrows(this,mbslidersectionid);              
            },
            resize: function () {
              toggleSliderArrows(this,mbslidersectionid);
            },          
          slideChange: function (el) {
            if(document.querySelector("#mbslider-"+mbslidersectionid)){
              if(document.querySelector("#mbslider-"+mbslidersectionid).classList.contains("slide-rotating")){
              }else{
                document.querySelector("#mbslider-"+mbslidersectionid).classList.add("slide-rotating");                
              }
            }
            var currentSlide = el.slides[el.activeIndex];
            if(currentSlide){
                /* Stop the video */
                var alliFrame = document.querySelectorAll("#mbslider-" + mbslidersectionid + " iframe");
                if (alliFrame.length > 0) {
                  alliFrame.forEach(function (video) {
                    if (video.classList.contains("js-youtube")) {
                      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
                    }
                    if (video.classList.contains("js-vimeo")) {
                      video.contentWindow.postMessage('{"method":"pause"}',"https://player.vimeo.com");
                    }
                  });
                  
                  /* Start current video */
                  var currentiFrame = currentSlide.querySelector("iframe");
                  if (currentiFrame) 
                  {
                    if (currentiFrame.classList.contains("js-youtube")) {
                      if (currentiFrame.getAttribute('src') === null) {
                        currentiFrame.setAttribute('src', currentiFrame.getAttribute('data-src'));
                        currentiFrame.addEventListener('load', function () {
                          currentiFrame.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
                        });
                      }else{
                        currentiFrame.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
                      }
                    }
                    if (currentiFrame.classList.contains("js-vimeo")) {
                      if (currentiFrame.getAttribute('src') === null) {
                        currentiFrame.setAttribute('src', currentiFrame.getAttribute('data-src'));
                        currentiFrame.addEventListener('load', function () {
                          currentiFrame.contentWindow.postMessage('{"method":"play"}',"https://player.vimeo.com");
                        });
                      }else{
                          currentiFrame.contentWindow.postMessage('{"method":"play"}',"https://player.vimeo.com");
                      }
                    }
                  }
                }
                var allVideos = document.querySelectorAll(
                  "#mbslider-" + mbslidersectionid + " video"
                );
                if (allVideos.length > 0) {
                  allVideos.forEach(function (video) {
                    video.pause();
                  });
                  var currentVideo = currentSlide.querySelector("video");
                  if (currentVideo != null) {
                    currentVideo.play();
                  }
                }
              }
          }, /* Slider Change End */
        }
      });

      if(numofrows > 1){
        mySwiper.params.spaceBetween = 20;
      }
      if (gridcolumn_mobile != "" && gridcolumn_ipads != "" && gridcolumn_tablet != "" && gridcolumn_desktop != "" && (slidesauto == null || numofrows > 1)) {
        
        mySwiper.params.breakpoints = {
          1: {
            slidesPerView: gridcolumn_mobile,
             grid: { rows: 1, fill: "row" },
          },
          768: {
            slidesPerView: gridcolumn_ipads
          },
          992: {
            slidesPerView: gridcolumn_tablet
          },
          1200: {
            slidesPerView: gridcolumn_desktop,
             grid: { rows: numofrows, fill: "row" },
          }
        };
      } 
    } /* Globalslider function end */

function toggleSliderArrows(swiper,mbslidersectionid) {
  var totalSlides = swiper.slides.length;
  var slidesPerView = swiper.params.slidesPerView;
  if (totalSlides <= slidesPerView) {
    if(document.querySelector(".mbprevbtn-"+mbslidersectionid)){
      document.querySelector(".mbprevbtn-"+mbslidersectionid).style.display = "none";
    }
    if(document.querySelector(".mbnextbtn-"+mbslidersectionid)){
      document.querySelector(".mbnextbtn-"+mbslidersectionid).style.display = "none";
    }
  } else {
    if(document.querySelector(".mbprevbtn-"+mbslidersectionid)){
      document.querySelector(".mbprevbtn-"+mbslidersectionid).style.display = "show";
    }
    if(document.querySelector(".mbnextbtn-"+mbslidersectionid)){
      document.querySelector(".mbnextbtn-"+mbslidersectionid).style.display = "show";
    }
  }
}
/* ================================== End of Swiper Global Script ================================== */


/* ================================== Custom Add to Cart Script ================================== */
function customaddtocartscript(){
var commonconfigval = document.getElementById("commmonconfigval");
  if(commonconfigval){
      var template = commonconfigval.dataset.template;
      if(template != "cart"){
          addtocartbtnevent();
          cdqtyupdateremove();
		  if (typeof StorePickupAvailability === 'undefined' && window.storepickupavailability != "") {
              loadScriptsDelay(window.storepickupavailability, function () {
                productvariantscript();
              });
          }else{
              productvariantscript();
          }  
      }else{
        cartpagescript();
      }  /* template condition */
  } /* commonconfigval condition */
}  /* commonconfigval script */

function addtocartbtnevent(){
  
	var commonconfigval = document.getElementById("commmonconfigval");
	var carttype = commonconfigval.dataset.carttype;
    document.querySelectorAll('.quick-add-submit:not(.listening)').forEach(button => {
      button.classList.add('listening');
      button.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          button.classList.add('loading');
          var form = event.target.closest('form');			
          var formData = new FormData(form);

          /* for Bundle and FBT Product */
          if (formData.has('bid')) {
              var bidValue = formData.get('bid');
              formData.set('id', bidValue);
          }
          if (formData.has('bquantity')) {
              var bquantity = formData.get('bquantity');
              formData.set('quantity', bquantity);
          }	      
          handleErrorMessage();
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];   
          config.body = formData;
          
          fetch('/cart/add.js', config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) 
            {	
              handleErrorMessage(response.description);
              const soldOutMessage = button.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              button.setAttribute('aria-disabled', true);
              button.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              
              this.error = true;
              return;
            }
            this.error = false;    
			
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
              button.classList.remove('loading');
              button.classList.add('added');
              setTimeout(() => {
                  button.classList.remove('added');
              }, 300);

              if(carttype == "page"){
                window.location.href = '/cart';
              }else{
                updateCartDrawer();
              }
        });
        
        });
    });
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || document.querySelector('.product-form-error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form-error-message');
    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
}

function cdqtyupdateremove()
{
    document.querySelectorAll('.cart-drawer').forEach(function(container) {
		container.addEventListener('click', function(event) {
			if (event.target.classList.contains('quantity-button')) {
				event.preventDefault();
				var quantity = 1;
				var button = event.target;
                var qtybutton = event.target.closest('.quantity-button');
                var trElement = qtybutton.closest('tr');
                if (trElement) {
                    trElement.classList.add('qty-updateing');
                }              
				if (button.classList.contains('plus')) {
					var quantityInput = button.previousElementSibling;
					var quantity = parseInt(quantityInput.value);
					quantity++;
				} else if (button.classList.contains('minus')) {
					var quantityInput = button.nextElementSibling;
					var quantity = parseInt(quantityInput.value);				
					quantity--;
				}
				var dataIndex = quantityInput.getAttribute('data-index');
				/* quantityInput.value = quantity; */
				updateQuantity(dataIndex, quantity);       
               return;
			}
		});
	});

    document.addEventListener('click', function(event) {
        if (event.target.closest('.removeitem')) {
            event.preventDefault();
            const button = event.target.closest('.removeitem');
            const cartRemoveButton = button.closest('.cart-remove-button');
            const dataIndex = cartRemoveButton.getAttribute('data-index');
            var removebutton = event.target.closest('.removebtn');
                var trElement = removebutton.closest('tr');
                if (trElement) {
                    trElement.classList.add('removing');
                }
            updateQuantity(dataIndex, 0);
        }
    });
  
    document.body.addEventListener('input', function(event) {
        if (event.target.matches('.cart-item .quantity-input')) {
            const quantity = event.target.value;
            const dataIndex = event.target.getAttribute('data-index');
            if(quantity != ""){
                var trElement = event.target.closest('tr');
                  if (trElement) {
                      trElement.classList.add('removing');
                  }
                updateQuantity(dataIndex, quantity);
            }
        }
    });
}

function updateCartDrawer() 
{
  //console.log("updateCartDrawer");
  var siteheader = document.getElementById("site-header");
  if(siteheader){
    var headerstyle = siteheader.dataset.headerstyle;
  }  
  /* Update cart total */
  const cartTotalElement = document.querySelector('.totals-subtotal-value');
  if(!cartTotalElement) return;
    
  
  /* Clear current cart items */
  const cartItemsContainer = document.querySelector('.cart-items tbody');
  /* cartItemsContainer.innerHTML = ''; */
  if(!cartItemsContainer) return;
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => { 
      var commmonconfigval =  document.getElementById("commmonconfigval"); 
      const currencySymbol = commmonconfigval.dataset.currencysymbol;
	  const cartlblitem = commmonconfigval.dataset.cartlblitem;
	  const chkgiftwrap = commmonconfigval.dataset.chkgiftwrap;
	  const showvendor = commmonconfigval.dataset.showvendor;
	  const qtylbl = commmonconfigval.dataset.qtylbl;  
	  const qtydeclbl = commmonconfigval.dataset.qtydeclbl;  
	  const qtyinclbl = commmonconfigval.dataset.qtyinclbl;
	  const spinnericn = commmonconfigval.dataset.spinnericn;	  
	  const minusicon = commmonconfigval.dataset.minusicon;	  
	  const plusicon = commmonconfigval.dataset.plusicon;	  
	  const rmvbtn = commmonconfigval.dataset.rmvbtn;
	  const erroricon = commmonconfigval.dataset.erroricon;	  
  
      cartTotalElement.textContent = currencySymbol + Shopify.formatMoney(cart.total_price);
      
      if(cart.item_count == 0){
        document.querySelector(".cart-icon").classList.add("items0");
      }else{
        document.querySelector(".cart-icon").classList.remove("items0");
      }
      if(headerstyle == "6"){ 
        let minicartcount = document.querySelector('.site-header .cart-icon .cart-counter');
        minicartcount.innerHTML = '<span class="cart-total ml-5 d-none d-xl-inline">' +currencySymbol + Shopify.formatMoney(cart.total_price)+' - &nbsp;</span> ' + cart.item_count + '<span class="txt d-none d-xl-inline">&nbsp; '+ cartlblitem +'</span>';
      }else{ 
        let minicartcount = document.querySelector('.site-header .cart-icon .cart-counter');
        minicartcount.innerHTML = cart.item_count;      
      }

      if(document.querySelector('.mobilebtmstickycart .cart-count-items')){
        if(cart.item_count == 0){
           document.querySelector(".cart-icon").classList.add("items0");
        }else{
          document.querySelector(".cart-icon").classList.remove("items0");          
        }
        let stickycartcount = document.querySelector('.mobilebtmstickycart .cart-count-items');
        stickycartcount.innerHTML = cart.item_count;
      }

        var items_in_cart = 0;
        var gift_wraps_in_cart = 0;
    	var cart_size = 0;
        var giftwrapsid = 0;
        if (chkgiftwrap != "" || chkgiftwrap != null){        
          const itemsInCart = cart.items;
          cart_size = cart.item_count;
          var cartDrawerConfig = document.getElementById('rmgwcartdrawer');
          if(cartDrawerConfig){
              giftwrapsid = cartDrawerConfig.dataset.gwpid;
              itemsInCart.forEach(item => {
                  const itemId = item.id;
                  const itemQuantity = item.quantity;
                  if(itemId == giftwrapsid){
                      gift_wraps_in_cart = itemQuantity;
                  }
              });
              items_in_cart = cart.item_count - gift_wraps_in_cart;
              if(document.getElementById("itemsincart")){
                document.getElementById("itemsincart").dataset.value = items_in_cart;
              }
              cartDrawerConfig.dataset.cartsize = cart_size;
              cartDrawerConfig.dataset.itemincart = items_in_cart;
              cartDrawerConfig.dataset.giftwrapincart = gift_wraps_in_cart;
              removeGiftWrapCartDrawer();
          }          
		}

      /* Update cart items */
        fetch(window.Shopify.routes.root + '?section_id=cart-drawer-items') 
        .then(response => response.text())
        .then(html => {
          cartItemsContainer.innerHTML = html;
          cartItemsContainer.style.opacity = '1';
        })
        .catch(error => {
          console.error('Error fetching cart HTML:', error);
        });
      
      if(cart.item_count != 0){
        document.querySelectorAll('.emptydrawer').forEach(function(element) {
            element.classList.add('cart-drawer-empty');
            element.classList.remove('cart-drawer-show');          
        });
        document.querySelectorAll('.showdrawer').forEach(function(element) {
          element.classList.remove('cart-drawer-empty');
          element.classList.add('cart-drawer-show');
        });
        document.querySelectorAll('.cart-popup').forEach(function(element) {
          element.classList.remove('cart-is-empty');
        });
      }
      if(cart.item_count == 0){
        document.querySelectorAll('.emptydrawer').forEach(function(element) {
            element.classList.remove('cart-drawer-empty');
            element.classList.add('cart-drawer-show');
           
        });
         document.querySelectorAll('.cart-popup').forEach(function(element) {
          element.classList.add('cart-is-empty');
        });
        document.querySelectorAll('.showdrawer').forEach(function(element) {
            element.classList.add('cart-drawer-empty');
            element.classList.remove('cart-drawer-show');
        });
      }

    var cartDrawerCheckoutBtn = document.getElementById("CartDrawer-Checkout");
      if(cartDrawerCheckoutBtn){
          cartDrawerCheckoutBtn.removeAttribute("disabled");
      }
      
      /* Show or hide the empty cart message */
      if (document.getElementById("cart-popup") != null) {
        const cartPopup = document.getElementById('cart-popup');
        cartPopup.classList.add('active');
      }
      if (document.getElementById("cart-drawer") != null) {
        const cartDrawer = document.getElementById('cart-drawer');
        cartDrawer.classList.add('active');
        document.body.classList.add('offcanvas-open');
      }
    })
    .catch(error => {
      console.error('Error updating cart drawer:', error);
    });
}

function updateQuantity(linenum, quantity = 1) {
  fetch('/cart/change.js', {
	method: 'POST',
	headers: {
	  'Content-Type': 'application/json',
	  'Accept': 'application/json'
	},
	/* body: JSON.stringify({ line: linenum || productId, quantity: quantity }) */
    body: JSON.stringify({ line: linenum, quantity: quantity })
  })
  .then(response => {
      if (!response.ok) {
          return response.json().then(error => {
              if (response.status === 422) {
                alert(error.description);
              }
              if (response.status === 404) {
                alert(error.description);
              }
          });
      }
      return response.json();
  })
  .then(data => {
	updateCartDrawer();
  })
  .catch(error => {
	console.error('Error update to cart:', error);
  });
}

function productvariantscript(){
  const productFormInputs = document.querySelectorAll('.product-form-input');
    if (productFormInputs.length > 0) {
      const valuesObject = {};
      document.querySelectorAll('.product-form-input input:not(.listening)').forEach(function(radio) 
      {
          radio.classList.add('listening');
          if (radio.checked) {
            const proid = radio.getAttribute('data-productid');
            const key = radio.getAttribute('aria-label');
             const thisForm = document.querySelector("#"+radio.getAttribute('form'));
            getoptionstring(radio.value, key, proid, thisForm, null);
          }        
          radio.addEventListener('click', function(event) {
              const proid = this.getAttribute('data-productid');
              const key = this.getAttribute('aria-label');
             const thisForm = document.querySelector("#"+this.getAttribute('form'));
              getoptionstring(this.value,key,proid, thisForm, event);
          });
        });
    
        document.querySelectorAll('.product-form-input select:not(.listening)').forEach(function(select) 
        {  
          select.classList.add('listening');
          const proid = select.getAttribute('data-productid');
          const key = select.getAttribute('aria-label');
          const selectedOption = select.options[select.selectedIndex];
          const value = selectedOption.value;
          const thisForm = document.querySelector("#"+select.getAttribute('form'));
          getoptionstring(value, key, proid, thisForm, null);
          
          select.addEventListener('change', function(event) {
            const proid = this.getAttribute('data-productid');
            const key = this.getAttribute('aria-label');
            const selectedOption = this.options[this.selectedIndex];
            const value = selectedOption.value;
             const thisForm = document.querySelector("#"+this.getAttribute('form'));
            getoptionstring(value, key, proid, thisForm, event);
          });
        });
    
        function getoptionstring(value,key,proid, thisForm, event)
        {
         
          valuesObject[key] = value;
            var optionstring = "";
            for (const key in valuesObject) {
                if (valuesObject.hasOwnProperty(key)) {
                    optionstring += valuesObject[key]+"/";
                }
            }
       
            var selectBox = thisForm.closest('.product-info-wrapper').querySelector("#variantSelect-"+proid);
            var selectedVariantId = "";
            var selectedOption = "";
            var selectedVariantImage = "";
            var selectedVariantSku = "";
            var selectedVariantPrice = "";
            var selectedVariantQty = "";
            var selectedVariantStatus = "";
             
			if(selectBox != null){
             var optionTextToFind = optionstring.replace(/\/+$/, '');
             optionTextToFind = optionTextToFind.replace(/\s+/g, '');
             selectedVariantQty = selectBox.selectedOptions[0].getAttribute("data-qty");;
             
          
             if(optionTextToFind == ""){
               
                selectedVariantId = selectBox.value;
                selectedVariantImage = selectBox.selectedOptions[0].getAttribute("data-image");
                selectedVariantSku = selectBox.selectedOptions[0].getAttribute("data-sku");
                selectedVariantPrice = selectBox.selectedOptions[0].getAttribute("data-price");
                selectedVariantQty = selectBox.selectedOptions[0].getAttribute("data-qty");
                selectedVariantStatus = selectBox.selectedOptions[0].getAttribute("data-available");
               
             }else{
               for (var i = 0; i < selectBox.options.length; i++) {
                 if (selectBox.options[i].text === optionTextToFind) {
                 
                   selectBox.selectedIndex = i;
                   selectedVariantId = selectBox.options[i].value;
                   selectedVariantImage = selectBox.options[i].getAttribute("data-image");
                   selectedVariantSku = selectBox.options[i].getAttribute("data-sku");
                   selectedVariantPrice = selectBox.options[i].getAttribute("data-price");
                   selectedVariantQty = selectBox.options[i].getAttribute("data-qty");
                   selectedVariantStatus = selectBox.options[i].getAttribute("data-available");

                    const stickySelectElement = document.querySelector('.sticky-addtocart-bar-form select');
                    if(stickySelectElement){
                      stickySelectElement.value = selectBox.options[i].value;
                      stickySelectElement.dispatchEvent(new Event('change'));
                    }
                   break;
                 }
               }
             }
             var addToCartBtnMain = thisForm.querySelector('.addtocart-'+proid);
              if (selectedVariantStatus == "false") {
                  addToCartBtnMain.disabled = true;
                    addToCartBtnMain.querySelector("span.text").innerHTML = addToCartBtnMain.dataset.soldoutbuttontext;
              } else {
                addToCartBtnMain.disabled = false;
                  if((addToCartBtnMain.querySelector("span.text").innerHTML).trim() == (window.variantStrings.preOrder).trim()){
                    addToCartBtnMain.querySelector("span.text").innerHTML = addToCartBtnMain.dataset.preorderbuttontext;
                  }else{
                    addToCartBtnMain.querySelector("span.text").innerHTML = addToCartBtnMain.dataset.addtocartbuttontext;
                  }
              }           
                if(selectedVariantId != ""){
                  var itemid = thisForm.querySelector('input[name="id"]')
                  itemid.value = selectedVariantId;

                    var input_sku = selectedVariantId;
                    var productid = proid;  
                    let dynamicVarName = "myJSON_" + productid;
                    let variableValue = window[dynamicVarName];
                    let productPrice = thisForm.closest('.product-info-wrapper').querySelector('.price-item');
                    var selectedVariantPrice = selectedVariantPrice; //document.getElementById("variantSelect-"+productid).selectedOptions[0].getAttribute("data-price");  
                    if(variableValue != "" && typeof variableValue !== "undefined" && event != null && event !== "undefined"){
                        updateButtonNotifyMe(event,input_sku,variableValue);
                        if(event.target.closest('.product-info-wrapper').querySelector('.product-sku span')) {
                          event.target.closest('.product-info-wrapper').querySelector('.product-sku span').innerHTML = updateSKU(input_sku,variableValue);
                        }
                        if(selectedVariantPrice != null){
                          productPrice.textContent = selectedVariantPrice;
                        }
                    }

                
                  /*const pageTemplate = document.querySelector('.commmonconfigval').dataset.template.slice(0, 7);*/
               
                  if(event != null && event !== "undefined") {
                    if(event.target.closest('fieldset') != null){
                      event.target.closest('fieldset').querySelector('legend').innerHTML = event.target.getAttribute("aria-label") +" : <span class='variantname'>"+ event.target.value +"</span>";
                    }else if(event.target.closest('.product-form-input').querySelector('label') != null){
                      event.target.closest('.product-form-input').querySelector('label').innerHTML = event.target.getAttribute("aria-label") +" : <span class='variantname'>"+ event.target.value +"</span>";
                    }else{
                      
                    }
                  }
                 if(event != null && event !== "undefined"){
                   if(!event.target.closest('#chooseoptionModal') && !event.target.closest('#quickviewModal')){
                    var vid = selectedVariantId;
                    var replacedURL = window.location.href.split(/[?#]/)[0]+'?variant='+vid;
                    window.history.replaceState( {} , '', replacedURL);
                    if(document.querySelectorAll('.shareinput').length > 0){
                       document.querySelectorAll('.shareinput').forEach((item) => {
                        item.setAttribute("value",replacedURL);
                      });
                    }
                   const pickupAvailabilityElement = thisForm.closest('.product-info-wrapper').querySelector('store-pickup-availability');
                    if(pickupAvailabilityElement){
                      pickupAvailabilityElement.setAttribute('data-variant-id', vid);
                      pickupAvailabilityElement.loadPickupAvailability(vid);
                    }
                   }
                 }
                  
                  var event = new Event('change', {
                    'bubbles': true,
                    'cancelable': true
                  });
                  itemid.dispatchEvent(event);
                  
                }
            
			}          
        }

          
    }


  
}

function cartpagescript()
{
	var container = document.getElementById('main-cart-items');
	if (container) {
		container.addEventListener('click', function(event) {
			if (event.target.classList.contains('quantity-button')) {
				event.preventDefault();
				var quantity = 1;
				var button = event.target;   

				var qtybutton = event.target.closest('.quantity-button');
				var trElement = qtybutton.closest('tr');
				if (trElement) {
					trElement.classList.add('qty-updateing');
				}
			  
				if (button.classList.contains('plus')) {
					var quantityInput = button.previousElementSibling;
					var quantity = parseInt(quantityInput.value);
					//quantity++;
				} else if (button.classList.contains('minus')) {
					var quantityInput = button.nextElementSibling;
					var quantity = parseInt(quantityInput.value);				
					//quantity--;
				}
				var dataIndex = quantityInput.getAttribute('data-index');
				/* quantityInput.value = quantity; */
			  cartsecupdate(dataIndex, quantity);
			  return;
			}          
		}); /* container end */
	};

     document.addEventListener('click', function(event) {
        if (event.target.closest('.removebtn')) {
            event.preventDefault();
            const button = event.target.closest('.removebtn');
            const cartRemoveButton = button.closest('.cart-remove-button');
            const dataIndex = cartRemoveButton.getAttribute('data-index');
            var removebutton = event.target.closest('.removebtn');
                var trElement = removebutton.closest('tr');
                if (trElement) {
                    trElement.classList.add('removing');
                }
            cartsecupdate(dataIndex, 0);
        }
    });

     document.body.addEventListener('input', function(event) {
        if (event.target.matches('.cart-item .quantity-input')) {
            const quantity = event.target.value;
            const dataIndex = event.target.getAttribute('data-index');
            if(quantity != ""){
                var trElement = event.target.closest('tr');
                  if (trElement) {
                      trElement.classList.add('removing');
                  }
                cartsecupdate(dataIndex, quantity);
            }
        }
    });
	
	if(document.getElementById('empty-cart-button')){
	  var commonconfigval = document.getElementById("commmonconfigval"); 
	  var emptycartlbl = commonconfigval.dataset.emptycartlbl;
	  document.getElementById('empty-cart-button').addEventListener('click', function() {
		if (confirm(emptycartlbl)) {
			fetch('/cart/clear.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				}
			})
			.then(response => response.json())
			.then(data => {
				window.location.reload();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
			}
		});
	}
}

function cartsecupdate(line,quantity)
{
	var commonconfigval = document.getElementById("commmonconfigval");
	var chkgiftwrap = commonconfigval.dataset.chkgiftwrap;
	var emptycart = false;
	var items_in_cart = 0;
	var gift_wraps_in_cart = 0;
	var cart_size = 0;
   
	fetch('/cart/change.js', {
	  method: 'POST',
	  headers: {
		'Content-Type': 'application/json'
	  },
	  body: JSON.stringify({
		line: line,
		quantity: quantity
	  })
	})
	.then(response => {
			if (!response.ok) {
				return response.json().then(error => {
					if (response.status === 422) {
					  alert(error.description);
					  var qtyid = document.getElementById('Quantity-'+line);
					  qtyid.value = qtyid.value - 1;
					  throw new Error(`${error.message}: ${error.description}`);
					}
					if (response.status === 404) {
					  alert(error.description);
					  throw new Error(`${error.message}: ${error.description}`);
					}
				});
			}
			return response.json();
		})

	.then(cart => {
		if(cart.item_count == 0){
		  emptycart = true;
		}

		if(chkgiftwrap != "" && chkgiftwrap != null){
		  const itemsInCart = cart.items;
		  cart_size = cart.item_count;
		  var cartDrawerConfig = document.getElementById('rmgwcartdrawer');
		  if(cartDrawerConfig != null){
    		  var giftwrapsid = cartDrawerConfig.dataset.gwpid;
    		  itemsInCart.forEach(item => {
    			  const itemId = item.id;
    			  const itemQuantity = item.quantity;
    			  if(itemId == giftwrapsid){
    				  gift_wraps_in_cart = itemQuantity;
    			  }
    		  });  
    		  items_in_cart = cart.item_count - gift_wraps_in_cart;
    		  if(document.getElementById("itemsincart")){
    			document.getElementById("itemsincart").dataset.value = items_in_cart;
    		  }
          }
		  if(cartDrawerConfig != null){
			  var giftwrapsid = cartDrawerConfig.dataset.gwpid;
			  var cartItemElement = document.querySelector('.cartitem-' + giftwrapsid);              
			  if (cartItemElement) {
				  cartItemElement.classList.add("qty-updateing");
			  }
			  cartDrawerConfig.dataset.cartsize = cart_size;
			  cartDrawerConfig.dataset.itemincart = items_in_cart;
			  cartDrawerConfig.dataset.giftwrapincart = gift_wraps_in_cart;
			  removeGiftWrapCartDrawer();
		  }
		}
	})  
	.then(() => {
	  return fetch('/cart?view=ajax', {
		method: 'GET'
	  });
	})
	.then(response => response.text())
	.then(data => {
	 
	  if(emptycart == false){
		  document.querySelector(".cart-icon").classList.add("items0");
		  const parser = new DOMParser();
		  const doc = parser.parseFromString(data, 'text/html');
		  const cartitemlinenew = doc.querySelector('table.cart-items');
		  const cartitemlineold = document.querySelector('table.cart-items');
		  if (cartitemlineold && cartitemlinenew) {
			cartitemlineold.innerHTML = cartitemlinenew.innerHTML;
		  }

		  const cartSubTotalNew = doc.querySelector('.cart-subtotal');
		  const cartSubTotalOld = document.querySelector('.cart-subtotal');
		  if (cartSubTotalOld && cartSubTotalNew) {
			cartSubTotalOld.innerHTML = cartSubTotalNew.innerHTML;
		  }
		  const cartTotalNew = doc.querySelector('.cart-total');
		  const cartTotalOld = document.querySelector('.cart-total');
		  if (cartTotalOld && cartTotalNew) {
			cartTotalOld.innerHTML = cartTotalNew.innerHTML;
		  }
		let minicartcount = document.querySelector('.site-header .cart-icon .cart-counter');
		minicartcount.innerHTML = cart_size;
        qtyincdec();
	  }else{
		  document.querySelector('.cartwithdata').innerHTML = "";
		  document.querySelector('.cart-warnings').classList.remove("d-none");
		  document.querySelector(".cart-icon").classList.add("items0");
	  }  
	  
	})
	.catch(error => {
	  console.error('Error:', error);
	});
 }
/* ================================== End of Add to Cart Script ================================== */

/* ================================== Start of Cookie Banner Script ================================= */

 function getBannerEl() {
    return document.getElementById('cookies-banner');
  }

  function hideBanner(res) {
    getBannerEl().style.display = 'none';
  }

  function showBanner() {
   getBannerEl().style.display = 'block';
  }

  function handleAccept(e) {
    window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner);

    document.addEventListener('trackingConsentAccepted',function() {
      console.log('trackingConsentAccepted event fired');
    });
  }

  function handleDecline() {
    window.Shopify.customerPrivacy.setTrackingConsent(false,hideBanner);
  }

  function initCookieBanner() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
    const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();
    if(userCanBeTracked && userTrackingConsent === 'no_interaction') {
      showBanner();
    }
  }

  window.Shopify.loadFeatures([
    {
      name: 'consent-tracking-api',
      version: '0.1',
    }
  ],
  function(error) {
    if (error) {
      throw error;
    }
  });

/* ================================== End of Cookie Banner Script ================================= */

/*=================================== Start Ajaxinate pagination script ================================== */
function ajaxPagination(){

    if(window.infinite_scroll_style == "load_more_on_click"){
       var loading_method = 'click';
    }else{
       var loading_method =  'scroll'; 
    }
  

    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#product-grid-pagination',
      method: loading_method,
      offset: 200,
      loadingText: window.loadingText,
      callback: AjaxCallbackEvent
    });
    
    document.addEventListener("renderProductCount", function() {
      AjaxCallbackEvent();
        const endlessCollection = new Ajaxinate({
           container: '#product-grid',
           pagination: '#product-grid-pagination',
           method: loading_method,
           offset: 200,
           loadingText: window.loadingText,
           callback: AjaxCallbackEvent
        });
        
       
    });

}
/*=================================== End Ajaxinate pagination script ================================== */

/*=================================== Start of Exit Intent PopUp Script ================================================*/
function exitIntentPopUp(){
  if(document.querySelector('.exit-intent-popup') != null){
        //document.querySelector('.exit-intent-popup').classList.add('active');
        const CookieService = {
          setCookie(name, value, days) {
              let expires = '';
              if (days) {
                  const date = new Date();
                  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                  expires = '; expires=' + date.toUTCString();
              }
              document.cookie = name + '=' + (value || '')  + expires + ';';
          },

          getCookie(name) {
              const cookies = document.cookie.split(';');
              for (const cookie of cookies) {
                  if (cookie.indexOf(name + '=') > -1) {
                      return cookie.split('=')[1];
                  }
              }
              return null;
          }
        };

        const exit = e => {
          const shouldExit =
              [...e.target.classList].includes('exit-intent-popup') || 
              e.target.className === 'close' || 
              e.target.classList.contains('feather-x')  ||
            e.target.classList.contains('icon-close')  ||
              e.keyCode === 27; 
          if (shouldExit) {
              document.querySelector('.exit-intent-popup').classList.remove('active');
              document.body.classList.remove('modal-open');
              CookieService.setCookie('exitIntentShown', true, 0);
          }
        };

        const mouseEvent = e => {
            const shouldShowExitIntent =
                !e.toElement &&
                !e.relatedTarget &&
                e.clientY < 10;

            if (shouldShowExitIntent) {
                document.removeEventListener('mouseout', mouseEvent);
                document.querySelector('.exit-intent-popup').classList.add('active');
                document.body.classList.add('modal-open');
               if (typeof Swiper === "undefined") {
                 loadScriptsDelay(window.swiperscript, function () {
                   initializeGlobalSwiperSliders();
                   
                });
               }else{ 
                 initializeGlobalSwiperSliders();
               }
                
               /* CookieService.setCookie('exitIntentShown', true, 30);*/
            }
        };

        if (!CookieService.getCookie('exitIntentShown')) {
            setTimeout(() => {
                document.addEventListener('mouseout', mouseEvent);
                document.addEventListener('keydown', exit);
                document.querySelector('.exit-intent-popup').addEventListener('click', exit);
            }, 0);
        }
    }
}



/*=================================== Start of Exit Intent PopUp Script ================================================*/

/*=================================== Start Mobile Sticky Bottom Menu Script ===========================================*/

function mobileStickyBottomMenu(){

   if (document.querySelector('.menubar-mobile') != null) {
    const bar_menubar_mobile = document.querySelector('.menubar-mobile');
    document.querySelector('body').style.paddingBottom = bar_menubar_mobile.offsetHeight + 'px';
   
    if (bar_menubar_mobile.querySelector('.shop-menu')) {
      bar_menubar_mobile.querySelector('.shop-menu').addEventListener('click', function (event) {
        event.preventDefault();
        document.querySelector('.navmenu-toggle').click();
      });
    }
  }

}
/*=================================== End Mobile Sticky Bottom Menu Script =============================================*/

/*=================================== Start Ajax Data Inject Script ===================*/

/*function ajaxDataInject(targetClass, targetsectionID, targetContenttoGet, languageCurrencyFlag = 1)
{
     if(checkIfClassExists(targetClass)){ 
       
         ajaxdataContentURL = "/search?section_id="+targetsectionID; 
         fetch(ajaxdataContentURL)
          .then(response => response.text()) 
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
      
            const contentToInject = doc.querySelector(targetContenttoGet);
            const returnToInput = contentToInject.querySelector('input[name="return_to"]');
              if (returnToInput) {
                  returnToInput.value = window.location.href;
              }
            if (contentToInject) {
              const targetElement = document.querySelectorAll(targetClass);
              if (targetElement) {
                  targetElement.forEach(qs => {
                   qs.innerHTML = contentToInject.innerHTML; 
                  });
               } else {
                console.error(`Target element targetElement not found on the page.`);
              }
            } else {
              console.error(`Element with data attribute targetElement not found in the fetched page.`);
            }
          })
          .catch(error => {
            console.error('Error fetching the page:', error);
          }).finally(() => {
            if(languageCurrencyFlag){
              languageCurrencySwitcher();
            }
          });
     }
}*/

function ajaxDataInject(targetClass, targetsectionID, targetContenttoGet, languageCurrencyFlag = 1) {
 
  const ajaxdataContentURL = `${window.Shopify.routes.root}search?section_id=` + targetsectionID;
  const cacheKey = `ajax_cache_${ajaxdataContentURL}`;
  const cacheExpiryKey = `${cacheKey}_expiry`;
  const cacheExpiryTime = 15 * 60 * 1000; // 15 minutes in milliseconds

  // Function to check if a class exists
  function checkIfClassExists(targetClass) {
    return document.querySelectorAll(targetClass).length > 0;
  }

  if (isSessionStorageAvailable()) {
    const cachedData = sessionStorage.getItem(cacheKey);
    const cachedExpiry = sessionStorage.getItem(cacheExpiryKey);
    const now = new Date().getTime();

    // Check if data is available in sessionStorage and hasn't expired
    if (cachedData && cachedExpiry && now < cachedExpiry) {
      injectContent(cachedData); // Use cached data if available
     // console.log("Loaded from cache");
      return; // No need to fetch new data
    }
  } else {
    console.warn("SessionStorage is not available in this browser.");
  }

  // If no cached data or sessionStorage is unavailable, fetch new data from the server
  fetch(ajaxdataContentURL)
    .then(response => response.text())
    .then(html => {
      if (isSessionStorageAvailable()) {
        // Store the fetched HTML in session storage
        sessionStorage.setItem(cacheKey, html);
        sessionStorage.setItem(cacheExpiryKey, new Date().getTime() + cacheExpiryTime);
      }
      // Inject the fetched HTML content
      injectContent(html);
    })
    .catch(error => {
      console.error('Error fetching the page:', error);
    })
    .finally(() => {
      if (languageCurrencyFlag) {
        languageCurrencySwitcher();
      }
    });

  // Function to inject content into the target element(s)
  function injectContent(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const contentToInject = doc.querySelector(targetContenttoGet);

    if (contentToInject) {
      const returnToInput = contentToInject.querySelector('input[name="return_to"]');
      if (returnToInput) {
        returnToInput.value = window.location.href;
      }

      const targetElements = document.querySelectorAll(targetClass);
      if (targetElements) {
        targetElements.forEach(qs => {
          qs.innerHTML = contentToInject.innerHTML;
        });
      } else {
        console.error(`Target element not found on the page.`);
      }
    } else {
      console.error(`Element with data attribute targetContentToGet not found in the fetched page.`);
    }
  }
}

  
/*=================================== End of Ajax Data Inject Script===================*/

/*=================================== Start code to manage tabs - e.g. poduct description =======================*/
function productDescriptionTabsControl() {
    var tabs_description = document.querySelector('.tab-descriptions');
    if (tabs_description != null) {
        tabs_description.querySelectorAll('.collection-tab-cat:not(.listening)').forEach((item) => {
            item.classList.add("listening");
            item.addEventListener("click", function(event) {
                var tabs_description = document.querySelector('.tab-descriptions');

                // If on mobile, toggle the visibility of the tab content
                if (window.innerWidth <= 480) { // Mobile view breakpoint
                    // Toggle the active state on the clicked tab
                    this.classList.toggle('active');

                    // Toggle the visibility of the content for this tab
                    var content = tabs_description.querySelector('.' + this.dataset.collectiontab);
                    content.classList.toggle('unhidecattab');
                    content.classList.toggle('hidecattab');
                } else {
                    // For larger screens, behave normally
                    tabs_description.querySelectorAll('.collection-tab-cat').forEach((item) => {
                        item.classList.remove('active');
                    });
                    tabs_description.querySelectorAll('.collection-tab').forEach((item) => {
                        item.classList.remove('unhidecattab');
                        item.classList.add('hidecattab');
                    });

                    // Show the selected tab's content
                    tabs_description.querySelector('.' + this.dataset.collectiontab).classList.add('unhidecattab');
                    tabs_description.querySelector('.' + this.dataset.collectiontab).classList.remove('hidecattab');

                    // Set clicked tab to active
                    this.classList.add('active');
                }
            });
        });
    }
}

/*=================================== End code to manage tabs e.g. poduct description =======================*/

